"use strict";

import PerformanceTimer from "/app/deps/hologram/assets/js/performance_timer.mjs";

const startTime = performance.now();

globalThis.Hologram.pageReachableFunctionDefs = (deps) => {
	const {
		Bitstring,
		ERTS,
		HologramBoxedError,
		HologramInterpreterError,
		Interpreter,
		MemoryStorage,
		Type,
		Utils,
	} = deps;

	Interpreter.defineElixirFunction(
		"AlchemistBlog.AboutPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.AboutPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/about");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Blog.Post",
		"__changeset__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("body"), Type.atom("string")],
						[Type.atom("cover_image"), Type.atom("string")],
						[Type.atom("excerpt"), Type.atom("string")],
						[Type.atom("id"), Type.atom("id")],
						[Type.atom("inserted_at"), Type.atom("utc_datetime")],
						[Type.atom("notified_at"), Type.atom("utc_datetime")],
						[Type.atom("published_at"), Type.atom("utc_datetime")],
						[Type.atom("slug"), Type.atom("string")],
						[
							Type.atom("tags"),
							Type.tuple([Type.atom("array"), Type.atom("string")]),
						],
						[Type.atom("title"), Type.atom("string")],
						[Type.atom("updated_at"), Type.atom("utc_datetime")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Blog.Post",
		"__schema__",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("query")],
				guards: [],
				body: (context) => {
					return Elixir_Ecto_Query["__struct__/1"](
						Type.list([
							Type.tuple([Type.atom("aliases"), Type.map([])]),
							Type.tuple([Type.atom("assocs"), Type.list([])]),
							Type.tuple([Type.atom("combinations"), Type.list([])]),
							Type.tuple([Type.atom("distinct"), Type.atom("nil")]),
							Type.tuple([Type.atom("group_bys"), Type.list([])]),
							Type.tuple([Type.atom("havings"), Type.list([])]),
							Type.tuple([Type.atom("joins"), Type.list([])]),
							Type.tuple([Type.atom("limit"), Type.atom("nil")]),
							Type.tuple([Type.atom("lock"), Type.atom("nil")]),
							Type.tuple([Type.atom("offset"), Type.atom("nil")]),
							Type.tuple([Type.atom("order_bys"), Type.list([])]),
							Type.tuple([Type.atom("prefix"), Type.atom("nil")]),
							Type.tuple([Type.atom("preloads"), Type.list([])]),
							Type.tuple([Type.atom("select"), Type.atom("nil")]),
							Type.tuple([Type.atom("sources"), Type.atom("nil")]),
							Type.tuple([Type.atom("updates"), Type.list([])]),
							Type.tuple([Type.atom("wheres"), Type.list([])]),
							Type.tuple([Type.atom("windows"), Type.list([])]),
							Type.tuple([Type.atom("with_ctes"), Type.atom("nil")]),
							Type.tuple([
								Type.atom("from"),
								Elixir_Ecto_Query_FromExpr["__struct__/1"](
									Type.list([
										Type.tuple([Type.atom("as"), Type.atom("nil")]),
										Type.tuple([Type.atom("file"), Type.atom("nil")]),
										Type.tuple([Type.atom("hints"), Type.list([])]),
										Type.tuple([Type.atom("line"), Type.atom("nil")]),
										Type.tuple([Type.atom("params"), Type.list([])]),
										Type.tuple([
											Type.atom("source"),
											Type.tuple([
												Type.bitstring("posts"),
												Type.atom("Elixir.AlchemistBlog.Blog.Post"),
											]),
										]),
										Type.tuple([Type.atom("prefix"), Type.atom("nil")]),
									]),
								),
							]),
						]),
					);
				},
			},
			{
				params: (context) => [Type.atom("source")],
				guards: [],
				body: (context) => {
					return Type.bitstring("posts");
				},
			},
			{
				params: (context) => [Type.atom("prefix")],
				guards: [],
				body: (context) => {
					return Type.atom("nil");
				},
			},
			{
				params: (context) => [Type.atom("dump")],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("body"),
							Type.tuple([
								Type.atom("body"),
								Type.atom("string"),
								Type.atom("always"),
							]),
						],
						[
							Type.atom("cover_image"),
							Type.tuple([
								Type.atom("cover_image"),
								Type.atom("string"),
								Type.atom("always"),
							]),
						],
						[
							Type.atom("excerpt"),
							Type.tuple([
								Type.atom("excerpt"),
								Type.atom("string"),
								Type.atom("always"),
							]),
						],
						[
							Type.atom("id"),
							Type.tuple([
								Type.atom("id"),
								Type.atom("id"),
								Type.atom("always"),
							]),
						],
						[
							Type.atom("inserted_at"),
							Type.tuple([
								Type.atom("inserted_at"),
								Type.atom("utc_datetime"),
								Type.atom("always"),
							]),
						],
						[
							Type.atom("notified_at"),
							Type.tuple([
								Type.atom("notified_at"),
								Type.atom("utc_datetime"),
								Type.atom("always"),
							]),
						],
						[
							Type.atom("published_at"),
							Type.tuple([
								Type.atom("published_at"),
								Type.atom("utc_datetime"),
								Type.atom("always"),
							]),
						],
						[
							Type.atom("slug"),
							Type.tuple([
								Type.atom("slug"),
								Type.atom("string"),
								Type.atom("always"),
							]),
						],
						[
							Type.atom("tags"),
							Type.tuple([
								Type.atom("tags"),
								Type.tuple([Type.atom("array"), Type.atom("string")]),
								Type.atom("always"),
							]),
						],
						[
							Type.atom("title"),
							Type.tuple([
								Type.atom("title"),
								Type.atom("string"),
								Type.atom("always"),
							]),
						],
						[
							Type.atom("updated_at"),
							Type.tuple([
								Type.atom("updated_at"),
								Type.atom("utc_datetime"),
								Type.atom("always"),
							]),
						],
					]);
				},
			},
			{
				params: (context) => [Type.atom("load")],
				guards: [],
				body: (context) => {
					return Type.list([
						Type.tuple([Type.atom("id"), Type.atom("id")]),
						Type.tuple([Type.atom("title"), Type.atom("string")]),
						Type.tuple([Type.atom("slug"), Type.atom("string")]),
						Type.tuple([Type.atom("excerpt"), Type.atom("string")]),
						Type.tuple([Type.atom("body"), Type.atom("string")]),
						Type.tuple([
							Type.atom("tags"),
							Type.tuple([Type.atom("array"), Type.atom("string")]),
						]),
						Type.tuple([Type.atom("cover_image"), Type.atom("string")]),
						Type.tuple([Type.atom("published_at"), Type.atom("utc_datetime")]),
						Type.tuple([Type.atom("notified_at"), Type.atom("utc_datetime")]),
						Type.tuple([Type.atom("inserted_at"), Type.atom("utc_datetime")]),
						Type.tuple([Type.atom("updated_at"), Type.atom("utc_datetime")]),
					]);
				},
			},
			{
				params: (context) => [Type.atom("associations")],
				guards: [],
				body: (context) => {
					return Type.list([]);
				},
			},
			{
				params: (context) => [Type.atom("embeds")],
				guards: [],
				body: (context) => {
					return Type.list([]);
				},
			},
			{
				params: (context) => [Type.atom("updatable_fields")],
				guards: [],
				body: (context) => {
					return Type.tuple([
						Type.list([
							Type.atom("updated_at"),
							Type.atom("inserted_at"),
							Type.atom("notified_at"),
							Type.atom("published_at"),
							Type.atom("cover_image"),
							Type.atom("tags"),
							Type.atom("body"),
							Type.atom("excerpt"),
							Type.atom("slug"),
							Type.atom("title"),
							Type.atom("id"),
						]),
						Type.list([]),
					]);
				},
			},
			{
				params: (context) => [Type.atom("insertable_fields")],
				guards: [],
				body: (context) => {
					return Type.tuple([
						Type.list([
							Type.atom("updated_at"),
							Type.atom("inserted_at"),
							Type.atom("notified_at"),
							Type.atom("published_at"),
							Type.atom("cover_image"),
							Type.atom("tags"),
							Type.atom("body"),
							Type.atom("excerpt"),
							Type.atom("slug"),
							Type.atom("title"),
							Type.atom("id"),
						]),
						Type.list([]),
					]);
				},
			},
			{
				params: (context) => [Type.atom("redact_fields")],
				guards: [],
				body: (context) => {
					return Type.list([]);
				},
			},
			{
				params: (context) => [Type.atom("autogenerate_fields")],
				guards: [],
				body: (context) => {
					return Type.list([Type.atom("inserted_at"), Type.atom("updated_at")]);
				},
			},
			{
				params: (context) => [Type.atom("virtual_fields")],
				guards: [],
				body: (context) => {
					return Type.list([]);
				},
			},
			{
				params: (context) => [Type.atom("fields")],
				guards: [],
				body: (context) => {
					return Type.list([
						Type.atom("id"),
						Type.atom("title"),
						Type.atom("slug"),
						Type.atom("excerpt"),
						Type.atom("body"),
						Type.atom("tags"),
						Type.atom("cover_image"),
						Type.atom("published_at"),
						Type.atom("notified_at"),
						Type.atom("inserted_at"),
						Type.atom("updated_at"),
					]);
				},
			},
			{
				params: (context) => [Type.atom("query_fields")],
				guards: [],
				body: (context) => {
					return Type.list([
						Type.atom("id"),
						Type.atom("title"),
						Type.atom("slug"),
						Type.atom("excerpt"),
						Type.atom("body"),
						Type.atom("tags"),
						Type.atom("cover_image"),
						Type.atom("published_at"),
						Type.atom("notified_at"),
						Type.atom("inserted_at"),
						Type.atom("updated_at"),
					]);
				},
			},
			{
				params: (context) => [Type.atom("primary_key")],
				guards: [],
				body: (context) => {
					return Type.list([Type.atom("id")]);
				},
			},
			{
				params: (context) => [Type.atom("hash")],
				guards: [],
				body: (context) => {
					return Type.integer(125206375n);
				},
			},
			{
				params: (context) => [Type.atom("read_after_writes")],
				guards: [],
				body: (context) => {
					return Type.list([]);
				},
			},
			{
				params: (context) => [Type.atom("autogenerate_id")],
				guards: [],
				body: (context) => {
					return Type.tuple([
						Type.atom("id"),
						Type.atom("id"),
						Type.atom("id"),
					]);
				},
			},
			{
				params: (context) => [Type.atom("autogenerate")],
				guards: [],
				body: (context) => {
					return Type.list([
						Type.tuple([
							Type.list([Type.atom("inserted_at"), Type.atom("updated_at")]),
							Type.tuple([
								Type.atom("Elixir.Ecto.Schema"),
								Type.atom("__timestamps__"),
								Type.list([Type.atom("utc_datetime")]),
							]),
						]),
					]);
				},
			},
			{
				params: (context) => [Type.atom("autoupdate")],
				guards: [],
				body: (context) => {
					return Type.list([
						Type.tuple([
							Type.list([Type.atom("updated_at")]),
							Type.tuple([
								Type.atom("Elixir.Ecto.Schema"),
								Type.atom("__timestamps__"),
								Type.list([Type.atom("utc_datetime")]),
							]),
						]),
					]);
				},
			},
			{
				params: (context) => [Type.atom("loaded")],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__meta__"),
							Type.map([
								[
									Type.atom("__struct__"),
									Type.atom("Elixir.Ecto.Schema.Metadata"),
								],
								[Type.atom("context"), Type.atom("nil")],
								[Type.atom("prefix"), Type.atom("nil")],
								[
									Type.atom("schema"),
									Type.atom("Elixir.AlchemistBlog.Blog.Post"),
								],
								[Type.atom("source"), Type.bitstring("posts")],
								[Type.atom("state"), Type.atom("loaded")],
							]),
						],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.AlchemistBlog.Blog.Post"),
						],
						[Type.atom("body"), Type.atom("nil")],
						[Type.atom("cover_image"), Type.atom("nil")],
						[Type.atom("excerpt"), Type.atom("nil")],
						[Type.atom("id"), Type.atom("nil")],
						[Type.atom("inserted_at"), Type.atom("nil")],
						[Type.atom("notified_at"), Type.atom("nil")],
						[Type.atom("published_at"), Type.atom("nil")],
						[Type.atom("slug"), Type.atom("nil")],
						[Type.atom("tags"), Type.atom("nil")],
						[Type.atom("title"), Type.atom("nil")],
						[Type.atom("updated_at"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Blog.Post",
		"__schema__",
		2,
		"public",
		[
			{
				params: (context) => [Type.atom("field_source"), Type.atom("id")],
				guards: [],
				body: (context) => {
					return Type.atom("id");
				},
			},
			{
				params: (context) => [Type.atom("field_source"), Type.atom("title")],
				guards: [],
				body: (context) => {
					return Type.atom("title");
				},
			},
			{
				params: (context) => [Type.atom("field_source"), Type.atom("slug")],
				guards: [],
				body: (context) => {
					return Type.atom("slug");
				},
			},
			{
				params: (context) => [Type.atom("field_source"), Type.atom("excerpt")],
				guards: [],
				body: (context) => {
					return Type.atom("excerpt");
				},
			},
			{
				params: (context) => [Type.atom("field_source"), Type.atom("body")],
				guards: [],
				body: (context) => {
					return Type.atom("body");
				},
			},
			{
				params: (context) => [Type.atom("field_source"), Type.atom("tags")],
				guards: [],
				body: (context) => {
					return Type.atom("tags");
				},
			},
			{
				params: (context) => [
					Type.atom("field_source"),
					Type.atom("cover_image"),
				],
				guards: [],
				body: (context) => {
					return Type.atom("cover_image");
				},
			},
			{
				params: (context) => [
					Type.atom("field_source"),
					Type.atom("published_at"),
				],
				guards: [],
				body: (context) => {
					return Type.atom("published_at");
				},
			},
			{
				params: (context) => [
					Type.atom("field_source"),
					Type.atom("notified_at"),
				],
				guards: [],
				body: (context) => {
					return Type.atom("notified_at");
				},
			},
			{
				params: (context) => [
					Type.atom("field_source"),
					Type.atom("inserted_at"),
				],
				guards: [],
				body: (context) => {
					return Type.atom("inserted_at");
				},
			},
			{
				params: (context) => [
					Type.atom("field_source"),
					Type.atom("updated_at"),
				],
				guards: [],
				body: (context) => {
					return Type.atom("updated_at");
				},
			},
			{
				params: (context) => [Type.atom("type"), Type.atom("id")],
				guards: [],
				body: (context) => {
					return Type.atom("id");
				},
			},
			{
				params: (context) => [Type.atom("type"), Type.atom("title")],
				guards: [],
				body: (context) => {
					return Type.atom("string");
				},
			},
			{
				params: (context) => [Type.atom("type"), Type.atom("slug")],
				guards: [],
				body: (context) => {
					return Type.atom("string");
				},
			},
			{
				params: (context) => [Type.atom("type"), Type.atom("excerpt")],
				guards: [],
				body: (context) => {
					return Type.atom("string");
				},
			},
			{
				params: (context) => [Type.atom("type"), Type.atom("body")],
				guards: [],
				body: (context) => {
					return Type.atom("string");
				},
			},
			{
				params: (context) => [Type.atom("type"), Type.atom("tags")],
				guards: [],
				body: (context) => {
					return Type.tuple([Type.atom("array"), Type.atom("string")]);
				},
			},
			{
				params: (context) => [Type.atom("type"), Type.atom("cover_image")],
				guards: [],
				body: (context) => {
					return Type.atom("string");
				},
			},
			{
				params: (context) => [Type.atom("type"), Type.atom("published_at")],
				guards: [],
				body: (context) => {
					return Type.atom("utc_datetime");
				},
			},
			{
				params: (context) => [Type.atom("type"), Type.atom("notified_at")],
				guards: [],
				body: (context) => {
					return Type.atom("utc_datetime");
				},
			},
			{
				params: (context) => [Type.atom("type"), Type.atom("inserted_at")],
				guards: [],
				body: (context) => {
					return Type.atom("utc_datetime");
				},
			},
			{
				params: (context) => [Type.atom("type"), Type.atom("updated_at")],
				guards: [],
				body: (context) => {
					return Type.atom("utc_datetime");
				},
			},
			{
				params: (context) => [
					Type.atom("field_source"),
					Type.matchPlaceholder(),
				],
				guards: [],
				body: (context) => {
					return Type.atom("nil");
				},
			},
			{
				params: (context) => [Type.atom("type"), Type.matchPlaceholder()],
				guards: [],
				body: (context) => {
					return Type.atom("nil");
				},
			},
			{
				params: (context) => [
					Type.atom("virtual_type"),
					Type.matchPlaceholder(),
				],
				guards: [],
				body: (context) => {
					return Type.atom("nil");
				},
			},
			{
				params: (context) => [
					Type.atom("association"),
					Type.matchPlaceholder(),
				],
				guards: [],
				body: (context) => {
					return Type.atom("nil");
				},
			},
			{
				params: (context) => [Type.atom("embed"), Type.matchPlaceholder()],
				guards: [],
				body: (context) => {
					return Type.atom("nil");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Blog.Post",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__meta__"),
							Type.map([
								[
									Type.atom("__struct__"),
									Type.atom("Elixir.Ecto.Schema.Metadata"),
								],
								[Type.atom("context"), Type.atom("nil")],
								[Type.atom("prefix"), Type.atom("nil")],
								[
									Type.atom("schema"),
									Type.atom("Elixir.AlchemistBlog.Blog.Post"),
								],
								[Type.atom("source"), Type.bitstring("posts")],
								[Type.atom("state"), Type.atom("built")],
							]),
						],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.AlchemistBlog.Blog.Post"),
						],
						[Type.atom("body"), Type.atom("nil")],
						[Type.atom("cover_image"), Type.atom("nil")],
						[Type.atom("excerpt"), Type.atom("nil")],
						[Type.atom("id"), Type.atom("nil")],
						[Type.atom("inserted_at"), Type.atom("nil")],
						[Type.atom("notified_at"), Type.atom("nil")],
						[Type.atom("published_at"), Type.atom("nil")],
						[Type.atom("slug"), Type.atom("nil")],
						[Type.atom("tags"), Type.atom("nil")],
						[Type.atom("title"), Type.atom("nil")],
						[Type.atom("updated_at"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Blog.Post",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__meta__"),
								Type.map([
									[
										Type.atom("__struct__"),
										Type.atom("Elixir.Ecto.Schema.Metadata"),
									],
									[Type.atom("context"), Type.atom("nil")],
									[Type.atom("prefix"), Type.atom("nil")],
									[
										Type.atom("schema"),
										Type.atom("Elixir.AlchemistBlog.Blog.Post"),
									],
									[Type.atom("source"), Type.bitstring("posts")],
									[Type.atom("state"), Type.atom("built")],
								]),
							],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.AlchemistBlog.Blog.Post"),
							],
							[Type.atom("body"), Type.atom("nil")],
							[Type.atom("cover_image"), Type.atom("nil")],
							[Type.atom("excerpt"), Type.atom("nil")],
							[Type.atom("id"), Type.atom("nil")],
							[Type.atom("inserted_at"), Type.atom("nil")],
							[Type.atom("notified_at"), Type.atom("nil")],
							[Type.atom("published_at"), Type.atom("nil")],
							[Type.atom("slug"), Type.atom("nil")],
							[Type.atom("tags"), Type.atom("nil")],
							[Type.atom("title"), Type.atom("nil")],
							[Type.atom("updated_at"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.BlogIndexPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.BlogIndexPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/blog");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.BlogTagPage",
		"__layout_module__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.atom("Elixir.AlchemistBlog.Layout");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.BlogTagPage",
		"__layout_props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.list([]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.BlogTagPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("tag"),
								Type.atom("string"),
								Type.list([]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.BlogTagPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/blog/tag/:tag");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.BlogTagPage",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.AlchemistBlog.Components.BlogArchive"),
											Type.list([
												Type.tuple([
													Type.bitstring("posts"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("posts"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("tag_options"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("tag_options"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("filter"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("filter"),
																),
															]),
														]),
													]),
												]),
											]),
											Type.list([]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Components.BlogArchive",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("tag_options"),
								Type.atom("list"),
								Type.list([]),
							]),
							Type.tuple([
								Type.atom("posts"),
								Type.atom("list"),
								Type.list([]),
							]),
							Type.tuple([
								Type.atom("filter"),
								Type.atom("string"),
								Type.list([]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Components.BlogArchive",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("header"),
											Type.list([]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("h1"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"font-display text-3xl font-bold text-ink",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("Blog"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("p"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("mt-2 text-muted"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"Notes, experiments and lessons learned. Filter by topic:",
															),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("div"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("mt-6 flex flex-wrap gap-2"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("component"),
													Type.atom("Elixir.Hologram.UI.Link"),
													Type.list([
														Type.tuple([
															Type.bitstring("to"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Type.atom(
																			"Elixir.AlchemistBlog.BlogIndexPage",
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Type.bitstring([
																			Type.bitstringSegment(
																				Type.string(
																					"rounded-full px-4 py-1.5 text-sm font-medium transition ",
																				),
																				{ type: "binary" },
																			),
																			Type.bitstringSegment(
																				Interpreter.case(
																					Erlang["==/2"](
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("filter"),
																						),
																						Type.atom("nil"),
																					),
																					[
																						{
																							match: Type.atom("false"),
																							guards: [],
																							body: (context) => {
																								return Type.bitstring(
																									"border border-line/60 bg-surface text-muted hover:text-ink",
																								);
																							},
																						},
																						{
																							match: Type.atom("true"),
																							guards: [],
																							body: (context) => {
																								return Type.bitstring(
																									"bg-brand text-on-brand",
																								);
																							},
																						},
																					],
																					context,
																				),
																				{ type: "binary" },
																			),
																		]),
																	]),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    All\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Interpreter.comprehension(
													[
														{
															match: Type.variablePattern("option_1"),
															guards: [],
															body: (context) =>
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("tag_options"),
																),
														},
													],
													[],
													Type.list([]),
													false,
													(context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n    "),
															]),
															Type.tuple([
																Type.atom("component"),
																Type.atom("Elixir.Hologram.UI.Link"),
																Type.list([
																	Type.tuple([
																		Type.bitstring("to"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Type.atom(
																						"Elixir.AlchemistBlog.BlogTagPage",
																					),
																					Type.list([
																						Type.tuple([
																							Type.atom("tag"),
																							Interpreter.dotOperator(
																								context.vars.option_1,
																								Type.atom("label"),
																							),
																						]),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.bitstring("class"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Type.bitstring([
																						Type.bitstringSegment(
																							Type.string(
																								"tag-pill rounded-full px-4 py-1.5 text-sm font-medium transition ",
																							),
																							{ type: "binary" },
																						),
																						Type.bitstringSegment(
																							Interpreter.case(
																								Erlang["==/2"](
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("filter"),
																									),
																									Interpreter.dotOperator(
																										context.vars.option_1,
																										Type.atom("label"),
																									),
																								),
																								[
																									{
																										match: Type.atom("false"),
																										guards: [],
																										body: (context) => {
																											return Interpreter.dotOperator(
																												context.vars.option_1,
																												Type.atom("class"),
																											);
																										},
																									},
																									{
																										match: Type.atom("true"),
																										guards: [],
																										body: (context) => {
																											return Type.bitstring([
																												Type.bitstringSegment(
																													Interpreter.dotOperator(
																														context.vars
																															.option_1,
																														Type.atom("class"),
																													),
																													{ type: "binary" },
																												),
																												Type.bitstringSegment(
																													Type.string(
																														" tag-active",
																													),
																													{ type: "binary" },
																												),
																											]);
																										},
																									},
																								],
																								context,
																							),
																							{ type: "binary" },
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n      "),
																	]),
																	Type.tuple([
																		Type.atom("expression"),
																		Type.tuple([
																			Interpreter.dotOperator(
																				context.vars.option_1,
																				Type.atom("label"),
																			),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
														]);
													},
													context,
												),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("div"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("mt-8 grid gap-6"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Interpreter.comprehension(
													[
														{
															match: Type.variablePattern("post_2"),
															guards: [],
															body: (context) =>
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("posts"),
																),
														},
													],
													[
														(context) =>
															Interpreter.case(
																Erlang["==/2"](
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("filter"),
																	),
																	Type.atom("nil"),
																),
																[
																	{
																		match: Type.atom("false"),
																		guards: [],
																		body: (context) => {
																			return Elixir_Enum["member?/2"](
																				Interpreter.dotOperator(
																					context.vars.post_2,
																					Type.atom("tags"),
																				),
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("filter"),
																				),
																			);
																		},
																	},
																	{
																		match: Type.atom("true"),
																		guards: [],
																		body: (context) => {
																			return Type.atom("true");
																		},
																	},
																],
																context,
															),
													],
													Type.list([]),
													false,
													(context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n    "),
															]),
															Type.tuple([
																Type.atom("component"),
																Type.atom(
																	"Elixir.AlchemistBlog.Components.PostCard",
																),
																Type.list([
																	Type.tuple([
																		Type.bitstring("post"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([context.vars.post_2]),
																			]),
																		]),
																	]),
																]),
																Type.list([]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
														]);
													},
													context,
												),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Components.PostCard",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([Type.atom("post"), Type.atom("map"), Type.list([])]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Components.PostCard",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("article"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"group rounded-2xl border border-line/60 bg-surface p-6 transition hover:border-brand/50 hover:shadow-lg hover:shadow-brand/5",
															),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Interpreter.case(
													Interpreter.dotOperator(
														Interpreter.dotOperator(
															context.vars.vars_0,
															Type.atom("post"),
														),
														Type.atom("cover_image"),
													),
													[
														{
															match: Type.variablePattern("x_1"),
															guards: [
																(context) =>
																	Erlang["orelse/2"](
																		(context) =>
																			Erlang["=:=/2"](
																				context.vars.x_1,
																				Type.atom("false"),
																			),
																		(context) =>
																			Erlang["=:=/2"](
																				context.vars.x_1,
																				Type.atom("nil"),
																			),
																		context,
																	),
															],
															body: (context) => {
																return Type.atom("nil");
															},
														},
														{
															match: Type.matchPlaceholder(),
															guards: [],
															body: (context) => {
																return Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("a"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("href"),
																				Type.list([
																					Type.tuple([
																						Type.atom("expression"),
																						Type.tuple([
																							Type.bitstring([
																								Type.bitstringSegment(
																									Type.string("/posts/"),
																									{ type: "binary" },
																								),
																								Type.bitstringSegment(
																									Interpreter.dotOperator(
																										Interpreter.dotOperator(
																											context.vars.vars_0,
																											Type.atom("post"),
																										),
																										Type.atom("slug"),
																									),
																									{ type: "binary" },
																								),
																							]),
																						]),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"-mx-6 -mt-6 mb-5 block",
																						),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("img"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("src"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										Interpreter.dotOperator(
																											context.vars.vars_0,
																											Type.atom("post"),
																										),
																										Type.atom("cover_image"),
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("alt"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										Interpreter.dotOperator(
																											context.vars.vars_0,
																											Type.atom("post"),
																										),
																										Type.atom("title"),
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("loading"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("lazy"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"h-44 w-full rounded-t-2xl object-cover",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]);
															},
														},
													],
													context,
												),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("div"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"flex flex-wrap items-center gap-2 text-xs font-medium text-muted",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Interpreter.comprehension(
															[
																{
																	match: Type.variablePattern("tag_2"),
																	guards: [],
																	body: (context) =>
																		Interpreter.dotOperator(
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("post"),
																			),
																			Type.atom("tag_pills"),
																		),
																},
															],
															[],
															Type.list([]),
															false,
															(context) => {
																return Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n      "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("a"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("href"),
																				Type.list([
																					Type.tuple([
																						Type.atom("expression"),
																						Type.tuple([
																							Interpreter.dotOperator(
																								context.vars.tag_2,
																								Type.atom("href"),
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("expression"),
																						Type.tuple([
																							Type.bitstring([
																								Type.bitstringSegment(
																									Type.string(
																										"tag-pill rounded-full px-2.5 py-1 ",
																									),
																									{ type: "binary" },
																								),
																								Type.bitstringSegment(
																									Interpreter.dotOperator(
																										context.vars.tag_2,
																										Type.atom("class"),
																									),
																									{ type: "binary" },
																								),
																							]),
																						]),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Interpreter.dotOperator(
																						context.vars.tag_2,
																						Type.atom("label"),
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																]);
															},
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("post"),
																			),
																			Type.atom("date"),
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("aria-hidden"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("true"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("·"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("post"),
																			),
																			Type.atom("reading_minutes"),
																		),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(" min read"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("h3"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"mt-3 font-display text-xl font-semibold leading-snug text-ink",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("a"),
															Type.list([
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Type.bitstring([
																					Type.bitstringSegment(
																						Type.string("/posts/"),
																						{ type: "binary" },
																					),
																					Type.bitstringSegment(
																						Interpreter.dotOperator(
																							Interpreter.dotOperator(
																								context.vars.vars_0,
																								Type.atom("post"),
																							),
																							Type.atom("slug"),
																						),
																						{ type: "binary" },
																					),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"transition-colors group-hover:text-brand",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("post"),
																			),
																			Type.atom("title"),
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("p"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"mt-2 leading-relaxed text-muted",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("post"),
																	),
																	Type.atom("excerpt"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("a"),
													Type.list([
														Type.tuple([
															Type.bitstring("href"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Type.bitstring([
																			Type.bitstringSegment(
																				Type.string("/posts/"),
																				{ type: "binary" },
																			),
																			Type.bitstringSegment(
																				Interpreter.dotOperator(
																					Interpreter.dotOperator(
																						context.vars.vars_0,
																						Type.atom("post"),
																					),
																					Type.atom("slug"),
																				),
																				{ type: "binary" },
																			),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"mt-4 inline-flex items-center gap-1 text-sm font-medium text-brand transition-transform group-hover:gap-2",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    Read more "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("aria-hidden"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("true"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("→"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.HomePage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.HomePage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Layout",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("og_url"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring("https://alchemist-labs.dev/"),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("og_type"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.bitstring("website")]),
								]),
							]),
							Type.tuple([
								Type.atom("og_image"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring("/images/og-default.png"),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("og_description"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring(
											"A personal blog about Elixir, AI, technology and the craft of coding.",
										),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("og_title"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring(
											"Alchemist Labs · notes on Elixir, AI & code",
										),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("page_title"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring(
											"Alchemist Labs · notes on Elixir, AI & code",
										),
									]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.Layout",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([Type.atom("doctype"), Type.bitstring("html")]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("html"),
											Type.list([
												Type.tuple([
													Type.bitstring("lang"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("en"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("h-full bg-base"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("data-theme"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("dark"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("head"),
													Type.list([]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("charset"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("utf-8"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("viewport"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"width=device-width, initial-scale=1",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([
																Type.tuple([
																	Type.bitstring("src"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/js/site.js"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([
																Type.tuple([
																	Type.bitstring("async"),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.bitstring("src"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"https://www.googletagmanager.com/gtag/js?id=G-WPJDSQXW21",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([
																Type.tuple([
																	Type.bitstring("src"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/js/analytics.js"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("description"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_description"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:title"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_title"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:description"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_description"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:type"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_type"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:url"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_url"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("canonical"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_url"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:image"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_image"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:image:width"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("1200"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:image:height"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("630"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("property"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("og:site_name"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Alchemist Labs"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("twitter:card"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("summary_large_image"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("twitter:title"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_title"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("twitter:description"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_description"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("twitter:image"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("og_image"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("title"),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("page_title"),
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("preconnect"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"https://fonts.googleapis.com",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("preconnect"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"https://fonts.gstatic.com",
																			),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("crossorigin"),
																	Type.list([]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"https://fonts.googleapis.com/css2?family=Cinzel:wght@500;600;700&family=Spectral:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Cormorant+Garamond:ital,wght@1,500;1,600&display=swap",
																			),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("stylesheet"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("stylesheet"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/assets/css/app.css"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("alternate"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("type"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("application/rss+xml"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("title"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Alchemist Labs"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/feed.xml"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("icon"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/favicon.ico"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("sizes"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("any"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("theme-color"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("#0a0a0f"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("author"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Stefan Mojsilović"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([
																Type.tuple([
																	Type.bitstring("type"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("application/ld+json"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		'{"@context":"https://schema.org","@graph":[{"@id":"https://alchemist-labs.dev/#website","@type":"WebSite","description":"A personal blog about Elixir, AI, technology and the craft of coding.","name":"Alchemist Labs","publisher":{"@id":"https://alchemist-labs.dev/#organization"},"url":"https://alchemist-labs.dev/"},{"@id":"https://alchemist-labs.dev/#organization","@type":"Organization","logo":{"@type":"ImageObject","url":"https://alchemist-labs.dev/images/og-default.png"},"name":"Alchemist Labs","url":"https://alchemist-labs.dev/"},{"@id":"https://alchemist-labs.dev/#person","@type":"Person","image":"https://alchemist-labs.dev/images/og-default.png","name":"Stefan Mojsilović","sameAs":["https://github.com/Antikythera","https://www.linkedin.com/in/stefan-mojsilovi%C4%87-76687166/"],"url":"https://alchemist-labs.dev/"}]}',
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom("Elixir.Hologram.UI.Runtime"),
															Type.list([]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("body"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"min-h-full text-ink antialiased flex flex-col font-body",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("div"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("atmos-gradient"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("canvas"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("atmos-canvas"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("header"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"border-b border-line/60 bg-surface/80 backdrop-blur sticky top-0 z-10",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("nav"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"mx-auto flex max-w-3xl items-center justify-between px-6 py-4",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("component"),
																			Type.atom("Elixir.Hologram.UI.Link"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("to"),
																					Type.list([
																						Type.tuple([
																							Type.atom("expression"),
																							Type.tuple([
																								Type.atom(
																									"Elixir.AlchemistBlog.HomePage",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"group inline-flex items-baseline gap-2",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("span"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"logo-word text-xl font-semibold tracking-tight",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("data-text"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"Alchemist Labs",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("Alchemist Labs"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("div"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"flex items-center gap-6 text-sm font-medium text-muted",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("component"),
																					Type.atom("Elixir.Hologram.UI.Link"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("to"),
																							Type.list([
																								Type.tuple([
																									Type.atom("expression"),
																									Type.tuple([
																										Type.atom(
																											"Elixir.AlchemistBlog.HomePage",
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("Home"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("component"),
																					Type.atom("Elixir.Hologram.UI.Link"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("to"),
																							Type.list([
																								Type.tuple([
																									Type.atom("expression"),
																									Type.tuple([
																										Type.atom(
																											"Elixir.AlchemistBlog.BlogIndexPage",
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("Blog"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("component"),
																					Type.atom("Elixir.Hologram.UI.Link"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("to"),
																							Type.list([
																								Type.tuple([
																									Type.atom("expression"),
																									Type.tuple([
																										Type.atom(
																											"Elixir.AlchemistBlog.AboutPage",
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("About"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("component"),
																					Type.atom("Elixir.Hologram.UI.Link"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("to"),
																							Type.list([
																								Type.tuple([
																									Type.atom("expression"),
																									Type.tuple([
																										Type.atom(
																											"Elixir.AlchemistBlog.NewsletterPage",
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("Newsletter"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("button"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("type"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("button"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring(
																								"data-theme-toggle",
																							),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("1"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("aria-label"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"Toggle light/dark theme",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"inline-flex items-center transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("span"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"hero-sun size-5 theme-icon-dark",
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.list([]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("span"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"hero-moon size-5 theme-icon-light",
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.list([]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n          "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n      "),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("main"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"mx-auto w-full max-w-3xl flex-1 px-6 py-12",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("slot"),
																	Type.list([]),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("footer"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"border-t border-line/60 bg-surface/60",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("div"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"mx-auto flex max-w-3xl flex-col gap-1 px-6 py-8 text-sm text-muted",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("p"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"font-display text-base text-ink",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("Alchemist Labs"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("p"),
																			Type.list([]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"Transmuting ideas about Elixir, AI & technology into code.",
																					),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("div"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"mt-4 flex items-center gap-5",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("a"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("href"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"https://github.com/Antikythera",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("target"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("_blank"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("rel"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"noopener noreferrer",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("aria-label"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("GitHub"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"text-muted transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("span"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"icon-github size-5",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.bitstring("aria-hidden"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring("true"),
																										]),
																									]),
																								]),
																							]),
																							Type.list([]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n          "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("a"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("href"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"https://www.linkedin.com/in/stefan-mojsilovi%C4%87-76687166/",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("target"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("_blank"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("rel"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"noopener noreferrer",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("aria-label"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("LinkedIn"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"text-muted transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("span"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"icon-linkedin size-5",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.bitstring("aria-hidden"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring("true"),
																										]),
																									]),
																								]),
																							]),
																							Type.list([]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n          "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("a"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("href"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("/feed.xml"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("target"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("_blank"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("rel"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"noopener noreferrer",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("aria-label"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("RSS feed"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"text-muted transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("span"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"icon-rss size-5",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.bitstring("aria-hidden"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring("true"),
																										]),
																									]),
																								]),
																							]),
																							Type.list([]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n          "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("div"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"mt-3 flex items-center gap-3 text-xs text-muted/70",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("span"),
																					Type.list([]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("For agents:"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("a"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("href"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("/llms.txt"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("llms.txt"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("a"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("href"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("/sitemap.md"),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"transition-colors hover:text-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("sitemap.md"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("p"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"mt-2 text-xs text-muted/70",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"Built with Phoenix, LiveView & Hologram.",
																					),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n      "),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.NewsletterPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"AlchemistBlog.NewsletterPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/newsletter");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"DBConnection.SensitiveData",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.DBConnection.SensitiveData"),
						],
						[Type.atom("data"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"DBConnection.SensitiveData",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.DBConnection.SensitiveData"),
							],
							[Type.atom("data"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction("Decimal.Error", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__exception__"), Type.atom("true")],
					[Type.atom("__struct__"), Type.atom("Elixir.Decimal.Error")],
					[Type.atom("reason"), Type.atom("nil")],
					[Type.atom("signal"), Type.atom("nil")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Decimal.Error", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Decimal.Error")],
						[Type.atom("reason"), Type.atom("nil")],
						[Type.atom("signal"), Type.atom("nil")],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Duration", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Duration")],
					[Type.atom("day"), Type.integer(0n)],
					[Type.atom("hour"), Type.integer(0n)],
					[
						Type.atom("microsecond"),
						Type.tuple([Type.integer(0n), Type.integer(0n)]),
					],
					[Type.atom("minute"), Type.integer(0n)],
					[Type.atom("month"), Type.integer(0n)],
					[Type.atom("second"), Type.integer(0n)],
					[Type.atom("week"), Type.integer(0n)],
					[Type.atom("year"), Type.integer(0n)],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Duration", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Duration")],
						[Type.atom("day"), Type.integer(0n)],
						[Type.atom("hour"), Type.integer(0n)],
						[
							Type.atom("microsecond"),
							Type.tuple([Type.integer(0n), Type.integer(0n)]),
						],
						[Type.atom("minute"), Type.integer(0n)],
						[Type.atom("month"), Type.integer(0n)],
						[Type.atom("second"), Type.integer(0n)],
						[Type.atom("week"), Type.integer(0n)],
						[Type.atom("year"), Type.integer(0n)],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Ecto.Association.BelongsTo",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Ecto.Association.BelongsTo"),
						],
						[Type.atom("cardinality"), Type.atom("one")],
						[Type.atom("defaults"), Type.list([])],
						[Type.atom("field"), Type.atom("nil")],
						[Type.atom("on_cast"), Type.atom("nil")],
						[Type.atom("on_replace"), Type.atom("nil")],
						[Type.atom("owner"), Type.atom("nil")],
						[Type.atom("owner_key"), Type.atom("nil")],
						[Type.atom("queryable"), Type.atom("nil")],
						[Type.atom("related"), Type.atom("nil")],
						[Type.atom("related_key"), Type.atom("nil")],
						[Type.atom("relationship"), Type.atom("parent")],
						[Type.atom("unique"), Type.atom("true")],
						[Type.atom("where"), Type.list([])],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Association.BelongsTo",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Association.BelongsTo"),
							],
							[Type.atom("cardinality"), Type.atom("one")],
							[Type.atom("defaults"), Type.list([])],
							[Type.atom("field"), Type.atom("nil")],
							[Type.atom("on_cast"), Type.atom("nil")],
							[Type.atom("on_replace"), Type.atom("nil")],
							[Type.atom("owner"), Type.atom("nil")],
							[Type.atom("owner_key"), Type.atom("nil")],
							[Type.atom("queryable"), Type.atom("nil")],
							[Type.atom("related"), Type.atom("nil")],
							[Type.atom("related_key"), Type.atom("nil")],
							[Type.atom("relationship"), Type.atom("parent")],
							[Type.atom("unique"), Type.atom("true")],
							[Type.atom("where"), Type.list([])],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Association.NotLoaded",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__cardinality__"), Type.atom("nil")],
						[Type.atom("__field__"), Type.atom("nil")],
						[Type.atom("__owner__"), Type.atom("nil")],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Ecto.Association.NotLoaded"),
						],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Association.NotLoaded",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__cardinality__"), Type.atom("nil")],
							[Type.atom("__field__"), Type.atom("nil")],
							[Type.atom("__owner__"), Type.atom("nil")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Association.NotLoaded"),
							],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Changeset",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Changeset")],
						[Type.atom("action"), Type.atom("nil")],
						[Type.atom("changes"), Type.map([])],
						[Type.atom("constraints"), Type.list([])],
						[Type.atom("data"), Type.atom("nil")],
						[Type.atom("empty_values"), Type.list([Type.bitstring("")])],
						[Type.atom("errors"), Type.list([])],
						[Type.atom("filters"), Type.map([])],
						[Type.atom("params"), Type.atom("nil")],
						[Type.atom("prepare"), Type.list([])],
						[Type.atom("repo"), Type.atom("nil")],
						[Type.atom("repo_opts"), Type.list([])],
						[Type.atom("required"), Type.list([])],
						[Type.atom("types"), Type.map([])],
						[Type.atom("valid?"), Type.atom("false")],
						[Type.atom("validations"), Type.list([])],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Changeset",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Changeset")],
							[Type.atom("action"), Type.atom("nil")],
							[Type.atom("changes"), Type.map([])],
							[Type.atom("constraints"), Type.list([])],
							[Type.atom("data"), Type.atom("nil")],
							[Type.atom("empty_values"), Type.list([Type.bitstring("")])],
							[Type.atom("errors"), Type.list([])],
							[Type.atom("filters"), Type.map([])],
							[Type.atom("params"), Type.atom("nil")],
							[Type.atom("prepare"), Type.list([])],
							[Type.atom("repo"), Type.atom("nil")],
							[Type.atom("repo_opts"), Type.list([])],
							[Type.atom("required"), Type.list([])],
							[Type.atom("types"), Type.map([])],
							[Type.atom("valid?"), Type.atom("false")],
							[Type.atom("validations"), Type.list([])],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction("Ecto.Embedded", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Embedded")],
					[Type.atom("cardinality"), Type.atom("nil")],
					[Type.atom("field"), Type.atom("nil")],
					[Type.atom("on_cast"), Type.atom("nil")],
					[Type.atom("on_replace"), Type.atom("raise")],
					[Type.atom("ordered"), Type.atom("true")],
					[Type.atom("owner"), Type.atom("nil")],
					[Type.atom("related"), Type.atom("nil")],
					[Type.atom("unique"), Type.atom("true")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Ecto.Embedded", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Embedded")],
						[Type.atom("cardinality"), Type.atom("nil")],
						[Type.atom("field"), Type.atom("nil")],
						[Type.atom("on_cast"), Type.atom("nil")],
						[Type.atom("on_replace"), Type.atom("raise")],
						[Type.atom("ordered"), Type.atom("true")],
						[Type.atom("owner"), Type.atom("nil")],
						[Type.atom("related"), Type.atom("nil")],
						[Type.atom("unique"), Type.atom("true")],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Ecto.NoPrimaryKeyFieldError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Ecto.NoPrimaryKeyFieldError"),
						],
						[Type.atom("message"), Type.atom("nil")],
						[Type.atom("schema"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.NoPrimaryKeyFieldError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.NoPrimaryKeyFieldError"),
							],
							[Type.atom("message"), Type.atom("nil")],
							[Type.atom("schema"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.NoPrimaryKeyValueError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Ecto.NoPrimaryKeyValueError"),
						],
						[Type.atom("message"), Type.atom("nil")],
						[Type.atom("struct"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.NoPrimaryKeyValueError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.NoPrimaryKeyValueError"),
							],
							[Type.atom("message"), Type.atom("nil")],
							[Type.atom("struct"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction("Ecto.Query", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Query")],
					[Type.atom("aliases"), Type.map([])],
					[Type.atom("assocs"), Type.list([])],
					[Type.atom("combinations"), Type.list([])],
					[Type.atom("distinct"), Type.atom("nil")],
					[Type.atom("from"), Type.atom("nil")],
					[Type.atom("group_bys"), Type.list([])],
					[Type.atom("havings"), Type.list([])],
					[Type.atom("joins"), Type.list([])],
					[Type.atom("limit"), Type.atom("nil")],
					[Type.atom("lock"), Type.atom("nil")],
					[Type.atom("offset"), Type.atom("nil")],
					[Type.atom("order_bys"), Type.list([])],
					[Type.atom("prefix"), Type.atom("nil")],
					[Type.atom("preloads"), Type.list([])],
					[Type.atom("select"), Type.atom("nil")],
					[Type.atom("sources"), Type.atom("nil")],
					[Type.atom("updates"), Type.list([])],
					[Type.atom("wheres"), Type.list([])],
					[Type.atom("windows"), Type.list([])],
					[Type.atom("with_ctes"), Type.atom("nil")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Ecto.Query", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Query")],
						[Type.atom("aliases"), Type.map([])],
						[Type.atom("assocs"), Type.list([])],
						[Type.atom("combinations"), Type.list([])],
						[Type.atom("distinct"), Type.atom("nil")],
						[Type.atom("from"), Type.atom("nil")],
						[Type.atom("group_bys"), Type.list([])],
						[Type.atom("havings"), Type.list([])],
						[Type.atom("joins"), Type.list([])],
						[Type.atom("limit"), Type.atom("nil")],
						[Type.atom("lock"), Type.atom("nil")],
						[Type.atom("offset"), Type.atom("nil")],
						[Type.atom("order_bys"), Type.list([])],
						[Type.atom("prefix"), Type.atom("nil")],
						[Type.atom("preloads"), Type.list([])],
						[Type.atom("select"), Type.atom("nil")],
						[Type.atom("sources"), Type.atom("nil")],
						[Type.atom("updates"), Type.list([])],
						[Type.atom("wheres"), Type.list([])],
						[Type.atom("windows"), Type.list([])],
						[Type.atom("with_ctes"), Type.atom("nil")],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Ecto.Query.BooleanExpr",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Ecto.Query.BooleanExpr"),
						],
						[Type.atom("expr"), Type.atom("nil")],
						[Type.atom("file"), Type.atom("nil")],
						[Type.atom("line"), Type.atom("nil")],
						[Type.atom("op"), Type.atom("nil")],
						[Type.atom("params"), Type.list([])],
						[Type.atom("subqueries"), Type.list([])],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.BooleanExpr",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Query.BooleanExpr"),
							],
							[Type.atom("expr"), Type.atom("nil")],
							[Type.atom("file"), Type.atom("nil")],
							[Type.atom("line"), Type.atom("nil")],
							[Type.atom("op"), Type.atom("nil")],
							[Type.atom("params"), Type.list([])],
							[Type.atom("subqueries"), Type.list([])],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.ByExpr",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Query.ByExpr")],
						[Type.atom("expr"), Type.atom("nil")],
						[Type.atom("file"), Type.atom("nil")],
						[Type.atom("line"), Type.atom("nil")],
						[Type.atom("params"), Type.list([])],
						[Type.atom("subqueries"), Type.list([])],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.ByExpr",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Query.ByExpr")],
							[Type.atom("expr"), Type.atom("nil")],
							[Type.atom("file"), Type.atom("nil")],
							[Type.atom("line"), Type.atom("nil")],
							[Type.atom("params"), Type.list([])],
							[Type.atom("subqueries"), Type.list([])],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.CastError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Query.CastError")],
						[Type.atom("message"), Type.atom("nil")],
						[Type.atom("type"), Type.atom("nil")],
						[Type.atom("value"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.CastError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Query.CastError"),
							],
							[Type.atom("message"), Type.atom("nil")],
							[Type.atom("type"), Type.atom("nil")],
							[Type.atom("value"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.CompileError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Ecto.Query.CompileError"),
						],
						[Type.atom("message"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.CompileError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Query.CompileError"),
							],
							[Type.atom("message"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.DynamicExpr",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Ecto.Query.DynamicExpr"),
						],
						[Type.atom("binding"), Type.atom("nil")],
						[Type.atom("file"), Type.atom("nil")],
						[Type.atom("fun"), Type.atom("nil")],
						[Type.atom("line"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.DynamicExpr",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Query.DynamicExpr"),
							],
							[Type.atom("binding"), Type.atom("nil")],
							[Type.atom("file"), Type.atom("nil")],
							[Type.atom("fun"), Type.atom("nil")],
							[Type.atom("line"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.FromExpr",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Query.FromExpr")],
						[Type.atom("as"), Type.atom("nil")],
						[Type.atom("file"), Type.atom("nil")],
						[Type.atom("hints"), Type.list([])],
						[Type.atom("line"), Type.atom("nil")],
						[Type.atom("params"), Type.list([])],
						[Type.atom("prefix"), Type.atom("nil")],
						[Type.atom("source"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.FromExpr",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Query.FromExpr"),
							],
							[Type.atom("as"), Type.atom("nil")],
							[Type.atom("file"), Type.atom("nil")],
							[Type.atom("hints"), Type.list([])],
							[Type.atom("line"), Type.atom("nil")],
							[Type.atom("params"), Type.list([])],
							[Type.atom("prefix"), Type.atom("nil")],
							[Type.atom("source"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.JoinExpr",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Query.JoinExpr")],
						[Type.atom("as"), Type.atom("nil")],
						[Type.atom("assoc"), Type.atom("nil")],
						[Type.atom("file"), Type.atom("nil")],
						[Type.atom("hints"), Type.list([])],
						[Type.atom("ix"), Type.atom("nil")],
						[Type.atom("line"), Type.atom("nil")],
						[Type.atom("on"), Type.atom("nil")],
						[Type.atom("params"), Type.list([])],
						[Type.atom("prefix"), Type.atom("nil")],
						[Type.atom("qual"), Type.atom("nil")],
						[Type.atom("source"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.JoinExpr",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Query.JoinExpr"),
							],
							[Type.atom("as"), Type.atom("nil")],
							[Type.atom("assoc"), Type.atom("nil")],
							[Type.atom("file"), Type.atom("nil")],
							[Type.atom("hints"), Type.list([])],
							[Type.atom("ix"), Type.atom("nil")],
							[Type.atom("line"), Type.atom("nil")],
							[Type.atom("on"), Type.atom("nil")],
							[Type.atom("params"), Type.list([])],
							[Type.atom("prefix"), Type.atom("nil")],
							[Type.atom("qual"), Type.atom("nil")],
							[Type.atom("source"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.LimitExpr",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Query.LimitExpr")],
						[Type.atom("expr"), Type.atom("nil")],
						[Type.atom("file"), Type.atom("nil")],
						[Type.atom("line"), Type.atom("nil")],
						[Type.atom("params"), Type.list([])],
						[Type.atom("with_ties"), Type.atom("false")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.LimitExpr",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Query.LimitExpr"),
							],
							[Type.atom("expr"), Type.atom("nil")],
							[Type.atom("file"), Type.atom("nil")],
							[Type.atom("line"), Type.atom("nil")],
							[Type.atom("params"), Type.list([])],
							[Type.atom("with_ties"), Type.atom("false")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.QueryExpr",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Query.QueryExpr")],
						[Type.atom("expr"), Type.atom("nil")],
						[Type.atom("file"), Type.atom("nil")],
						[Type.atom("line"), Type.atom("nil")],
						[Type.atom("params"), Type.list([])],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.QueryExpr",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Query.QueryExpr"),
							],
							[Type.atom("expr"), Type.atom("nil")],
							[Type.atom("file"), Type.atom("nil")],
							[Type.atom("line"), Type.atom("nil")],
							[Type.atom("params"), Type.list([])],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.SelectExpr",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Ecto.Query.SelectExpr"),
						],
						[Type.atom("aliases"), Type.map([])],
						[Type.atom("expr"), Type.atom("nil")],
						[Type.atom("fields"), Type.atom("nil")],
						[Type.atom("file"), Type.atom("nil")],
						[Type.atom("line"), Type.atom("nil")],
						[Type.atom("params"), Type.list([])],
						[Type.atom("subqueries"), Type.list([])],
						[Type.atom("take"), Type.map([])],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.SelectExpr",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Query.SelectExpr"),
							],
							[Type.atom("aliases"), Type.map([])],
							[Type.atom("expr"), Type.atom("nil")],
							[Type.atom("fields"), Type.atom("nil")],
							[Type.atom("file"), Type.atom("nil")],
							[Type.atom("line"), Type.atom("nil")],
							[Type.atom("params"), Type.list([])],
							[Type.atom("subqueries"), Type.list([])],
							[Type.atom("take"), Type.map([])],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.Tagged",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Query.Tagged")],
						[Type.atom("tag"), Type.atom("nil")],
						[Type.atom("type"), Type.atom("nil")],
						[Type.atom("value"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.Tagged",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Query.Tagged")],
							[Type.atom("tag"), Type.atom("nil")],
							[Type.atom("type"), Type.atom("nil")],
							[Type.atom("value"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.WithExpr",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Query.WithExpr")],
						[Type.atom("queries"), Type.list([])],
						[Type.atom("recursive"), Type.atom("false")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Query.WithExpr",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Query.WithExpr"),
							],
							[Type.atom("queries"), Type.list([])],
							[Type.atom("recursive"), Type.atom("false")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.QueryError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.QueryError")],
						[Type.atom("message"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.QueryError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[Type.atom("__struct__"), Type.atom("Elixir.Ecto.QueryError")],
							[Type.atom("message"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Repo.SensitiveData",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Ecto.Repo.SensitiveData"),
						],
						[Type.atom("data"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Repo.SensitiveData",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Repo.SensitiveData"),
							],
							[Type.atom("data"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Schema.Metadata",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Schema.Metadata")],
						[Type.atom("context"), Type.atom("nil")],
						[Type.atom("prefix"), Type.atom("nil")],
						[Type.atom("schema"), Type.atom("nil")],
						[Type.atom("source"), Type.atom("nil")],
						[Type.atom("state"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Schema.Metadata",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Schema.Metadata"),
							],
							[Type.atom("context"), Type.atom("nil")],
							[Type.atom("prefix"), Type.atom("nil")],
							[Type.atom("schema"), Type.atom("nil")],
							[Type.atom("source"), Type.atom("nil")],
							[Type.atom("state"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction("Ecto.SubQuery", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Ecto.SubQuery")],
					[Type.atom("cache"), Type.atom("nil")],
					[Type.atom("params"), Type.atom("nil")],
					[Type.atom("query"), Type.atom("nil")],
					[Type.atom("select"), Type.atom("nil")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Ecto.SubQuery", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.SubQuery")],
						[Type.atom("cache"), Type.atom("nil")],
						[Type.atom("params"), Type.atom("nil")],
						[Type.atom("query"), Type.atom("nil")],
						[Type.atom("select"), Type.atom("nil")],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Ecto.SubQueryError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.SubQueryError")],
						[Type.atom("exception"), Type.atom("nil")],
						[Type.atom("message"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.SubQueryError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[Type.atom("__struct__"), Type.atom("Elixir.Ecto.SubQueryError")],
							[Type.atom("exception"), Type.atom("nil")],
							[Type.atom("message"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Enum.EmptyError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Enum.EmptyError")],
						[Type.atom("message"), Type.bitstring("empty error")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Enum.EmptyError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[Type.atom("__struct__"), Type.atom("Elixir.Enum.EmptyError")],
							[Type.atom("message"), Type.bitstring("empty error")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Enum.OutOfBoundsError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Enum.OutOfBoundsError"),
						],
						[Type.atom("enumerable"), Type.atom("nil")],
						[Type.atom("index"), Type.atom("nil")],
						[Type.atom("message"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Enum.OutOfBoundsError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Enum.OutOfBoundsError"),
							],
							[Type.atom("enumerable"), Type.atom("nil")],
							[Type.atom("index"), Type.atom("nil")],
							[Type.atom("message"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Expo.Message.Plural",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__meta__"), Type.map([])],
						[Type.atom("__struct__"), Type.atom("Elixir.Expo.Message.Plural")],
						[Type.atom("comments"), Type.list([])],
						[Type.atom("extracted_comments"), Type.list([])],
						[Type.atom("flags"), Type.list([])],
						[Type.atom("msgctxt"), Type.atom("nil")],
						[Type.atom("msgid"), Type.atom("nil")],
						[Type.atom("msgid_plural"), Type.atom("nil")],
						[Type.atom("msgstr"), Type.map([])],
						[Type.atom("obsolete"), Type.atom("false")],
						[Type.atom("previous_messages"), Type.list([])],
						[Type.atom("references"), Type.list([])],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Expo.Message.Plural",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					Interpreter.matchOperator(
						Elixir_Enum["reduce/3"](
							context.vars.kv_0,
							Type.tuple([
								Type.map([
									[Type.atom("__meta__"), Type.map([])],
									[
										Type.atom("__struct__"),
										Type.atom("Elixir.Expo.Message.Plural"),
									],
									[Type.atom("comments"), Type.list([])],
									[Type.atom("extracted_comments"), Type.list([])],
									[Type.atom("flags"), Type.list([])],
									[Type.atom("msgctxt"), Type.atom("nil")],
									[Type.atom("msgid"), Type.atom("nil")],
									[Type.atom("msgid_plural"), Type.atom("nil")],
									[Type.atom("msgstr"), Type.map([])],
									[Type.atom("obsolete"), Type.atom("false")],
									[Type.atom("previous_messages"), Type.list([])],
									[Type.atom("references"), Type.list([])],
								]),
								Type.list([Type.atom("msgid"), Type.atom("msgid_plural")]),
							]),
							Type.anonymousFunction(
								2,
								[
									{
										params: (context) => [
											Type.tuple([
												Type.variablePattern("key_1"),
												Type.variablePattern("val_2"),
											]),
											Type.tuple([
												Type.variablePattern("map_3"),
												Type.variablePattern("keys_4"),
											]),
										],
										guards: [],
										body: (context) => {
											return Type.tuple([
												Elixir_Map["merge/2"](
													context.vars.map_3,
													Type.map([[context.vars.key_1, context.vars.val_2]]),
												),
												Elixir_List["delete/2"](
													context.vars.keys_4,
													context.vars.key_1,
												),
											]);
										},
									},
								],
								context,
							),
						),
						Type.tuple([
							Type.variablePattern("map_5"),
							Type.variablePattern("keys_6"),
						]),
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return Interpreter.case(
						context.vars.keys_6,
						[
							{
								match: Type.list([]),
								guards: [],
								body: (context) => {
									return context.vars.map_5;
								},
							},
							{
								match: Type.matchPlaceholder(),
								guards: [],
								body: (context) => {
									return Erlang["error/1"](
										Elixir_ArgumentError["exception/1"](
											Type.bitstring([
												Type.bitstringSegment(
													Type.string(
														"the following keys must also be given when building ",
													),
													{ type: "binary" },
												),
												Type.bitstringSegment(Type.string("struct "), {
													type: "binary",
												}),
												Type.bitstringSegment(
													Elixir_Kernel["inspect/1"](
														Type.atom("Elixir.Expo.Message.Plural"),
													),
													{ type: "binary" },
												),
												Type.bitstringSegment(Type.string(": "), {
													type: "binary",
												}),
												Type.bitstringSegment(
													Elixir_Kernel["inspect/1"](context.vars.keys_6),
													{ type: "binary" },
												),
											]),
										),
									);
								},
							},
						],
						context,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Expo.Message.Singular",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__meta__"), Type.map([])],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Expo.Message.Singular"),
						],
						[Type.atom("comments"), Type.list([])],
						[Type.atom("extracted_comments"), Type.list([])],
						[Type.atom("flags"), Type.list([])],
						[Type.atom("msgctxt"), Type.atom("nil")],
						[Type.atom("msgid"), Type.atom("nil")],
						[Type.atom("msgstr"), Type.list([Type.bitstring("")])],
						[Type.atom("obsolete"), Type.atom("false")],
						[Type.atom("previous_messages"), Type.list([])],
						[Type.atom("references"), Type.list([])],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Expo.Message.Singular",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					Interpreter.matchOperator(
						Elixir_Enum["reduce/3"](
							context.vars.kv_0,
							Type.tuple([
								Type.map([
									[Type.atom("__meta__"), Type.map([])],
									[
										Type.atom("__struct__"),
										Type.atom("Elixir.Expo.Message.Singular"),
									],
									[Type.atom("comments"), Type.list([])],
									[Type.atom("extracted_comments"), Type.list([])],
									[Type.atom("flags"), Type.list([])],
									[Type.atom("msgctxt"), Type.atom("nil")],
									[Type.atom("msgid"), Type.atom("nil")],
									[Type.atom("msgstr"), Type.list([Type.bitstring("")])],
									[Type.atom("obsolete"), Type.atom("false")],
									[Type.atom("previous_messages"), Type.list([])],
									[Type.atom("references"), Type.list([])],
								]),
								Type.list([Type.atom("msgid")]),
							]),
							Type.anonymousFunction(
								2,
								[
									{
										params: (context) => [
											Type.tuple([
												Type.variablePattern("key_1"),
												Type.variablePattern("val_2"),
											]),
											Type.tuple([
												Type.variablePattern("map_3"),
												Type.variablePattern("keys_4"),
											]),
										],
										guards: [],
										body: (context) => {
											return Type.tuple([
												Elixir_Map["merge/2"](
													context.vars.map_3,
													Type.map([[context.vars.key_1, context.vars.val_2]]),
												),
												Elixir_List["delete/2"](
													context.vars.keys_4,
													context.vars.key_1,
												),
											]);
										},
									},
								],
								context,
							),
						),
						Type.tuple([
							Type.variablePattern("map_5"),
							Type.variablePattern("keys_6"),
						]),
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return Interpreter.case(
						context.vars.keys_6,
						[
							{
								match: Type.list([]),
								guards: [],
								body: (context) => {
									return context.vars.map_5;
								},
							},
							{
								match: Type.matchPlaceholder(),
								guards: [],
								body: (context) => {
									return Erlang["error/1"](
										Elixir_ArgumentError["exception/1"](
											Type.bitstring([
												Type.bitstringSegment(
													Type.string(
														"the following keys must also be given when building ",
													),
													{ type: "binary" },
												),
												Type.bitstringSegment(Type.string("struct "), {
													type: "binary",
												}),
												Type.bitstringSegment(
													Elixir_Kernel["inspect/1"](
														Type.atom("Elixir.Expo.Message.Singular"),
													),
													{ type: "binary" },
												),
												Type.bitstringSegment(Type.string(": "), {
													type: "binary",
												}),
												Type.bitstringSegment(
													Elixir_Kernel["inspect/1"](context.vars.keys_6),
													{ type: "binary" },
												),
											]),
										),
									);
								},
							},
						],
						context,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Expo.PluralForms",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Expo.PluralForms")],
						[Type.atom("nplurals"), Type.atom("nil")],
						[Type.atom("plural"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Expo.PluralForms",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__struct__"), Type.atom("Elixir.Expo.PluralForms")],
							[Type.atom("nplurals"), Type.atom("nil")],
							[Type.atom("plural"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction("File.Stat", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.File.Stat")],
					[Type.atom("access"), Type.atom("nil")],
					[Type.atom("atime"), Type.atom("nil")],
					[Type.atom("ctime"), Type.atom("nil")],
					[Type.atom("gid"), Type.atom("nil")],
					[Type.atom("inode"), Type.atom("nil")],
					[Type.atom("links"), Type.atom("nil")],
					[Type.atom("major_device"), Type.atom("nil")],
					[Type.atom("minor_device"), Type.atom("nil")],
					[Type.atom("mode"), Type.atom("nil")],
					[Type.atom("mtime"), Type.atom("nil")],
					[Type.atom("size"), Type.atom("nil")],
					[Type.atom("type"), Type.atom("nil")],
					[Type.atom("uid"), Type.atom("nil")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("File.Stat", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.File.Stat")],
						[Type.atom("access"), Type.atom("nil")],
						[Type.atom("atime"), Type.atom("nil")],
						[Type.atom("ctime"), Type.atom("nil")],
						[Type.atom("gid"), Type.atom("nil")],
						[Type.atom("inode"), Type.atom("nil")],
						[Type.atom("links"), Type.atom("nil")],
						[Type.atom("major_device"), Type.atom("nil")],
						[Type.atom("minor_device"), Type.atom("nil")],
						[Type.atom("mode"), Type.atom("nil")],
						[Type.atom("mtime"), Type.atom("nil")],
						[Type.atom("size"), Type.atom("nil")],
						[Type.atom("type"), Type.atom("nil")],
						[Type.atom("uid"), Type.atom("nil")],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Finch.Error", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__exception__"), Type.atom("true")],
					[Type.atom("__struct__"), Type.atom("Elixir.Finch.Error")],
					[Type.atom("reason"), Type.atom("nil")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Finch.Error", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Finch.Error")],
						[Type.atom("reason"), Type.atom("nil")],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Finch.HTTPError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Finch.HTTPError")],
						[Type.atom("module"), Type.atom("nil")],
						[Type.atom("reason"), Type.atom("nil")],
						[Type.atom("source"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Finch.HTTPError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[Type.atom("__struct__"), Type.atom("Elixir.Finch.HTTPError")],
							[Type.atom("module"), Type.atom("nil")],
							[Type.atom("reason"), Type.atom("nil")],
							[Type.atom("source"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction("Finch.Pool", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Finch.Pool")],
					[Type.atom("host"), Type.atom("nil")],
					[Type.atom("port"), Type.atom("nil")],
					[Type.atom("scheme"), Type.atom("nil")],
					[Type.atom("tag"), Type.atom("default")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Finch.Pool", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				Interpreter.matchOperator(
					Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.tuple([
							Type.map([
								[Type.atom("__struct__"), Type.atom("Elixir.Finch.Pool")],
								[Type.atom("host"), Type.atom("nil")],
								[Type.atom("port"), Type.atom("nil")],
								[Type.atom("scheme"), Type.atom("nil")],
								[Type.atom("tag"), Type.atom("default")],
							]),
							Type.list([
								Type.atom("scheme"),
								Type.atom("host"),
								Type.atom("port"),
							]),
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.tuple([
											Type.variablePattern("map_3"),
											Type.variablePattern("keys_4"),
										]),
									],
									guards: [],
									body: (context) => {
										return Type.tuple([
											Elixir_Map["merge/2"](
												context.vars.map_3,
												Type.map([[context.vars.key_1, context.vars.val_2]]),
											),
											Elixir_List["delete/2"](
												context.vars.keys_4,
												context.vars.key_1,
											),
										]);
									},
								},
							],
							context,
						),
					),
					Type.tuple([
						Type.variablePattern("map_5"),
						Type.variablePattern("keys_6"),
					]),
					context,
				);
				Interpreter.updateVarsToMatchedValues(context);
				return Interpreter.case(
					context.vars.keys_6,
					[
						{
							match: Type.list([]),
							guards: [],
							body: (context) => {
								return context.vars.map_5;
							},
						},
						{
							match: Type.matchPlaceholder(),
							guards: [],
							body: (context) => {
								return Erlang["error/1"](
									Elixir_ArgumentError["exception/1"](
										Type.bitstring([
											Type.bitstringSegment(
												Type.string(
													"the following keys must also be given when building ",
												),
												{ type: "binary" },
											),
											Type.bitstringSegment(Type.string("struct "), {
												type: "binary",
											}),
											Type.bitstringSegment(
												Elixir_Kernel["inspect/1"](
													Type.atom("Elixir.Finch.Pool"),
												),
												{ type: "binary" },
											),
											Type.bitstringSegment(Type.string(": "), {
												type: "binary",
											}),
											Type.bitstringSegment(
												Elixir_Kernel["inspect/1"](context.vars.keys_6),
												{ type: "binary" },
											),
										]),
									),
								);
							},
						},
					],
					context,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Finch.Request", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Finch.Request")],
					[Type.atom("body"), Type.atom("nil")],
					[Type.atom("headers"), Type.atom("nil")],
					[Type.atom("host"), Type.atom("nil")],
					[Type.atom("method"), Type.atom("nil")],
					[Type.atom("path"), Type.atom("nil")],
					[Type.atom("pool_tag"), Type.atom("default")],
					[Type.atom("port"), Type.atom("nil")],
					[Type.atom("private"), Type.map([])],
					[Type.atom("query"), Type.atom("nil")],
					[Type.atom("scheme"), Type.atom("nil")],
					[Type.atom("unix_socket"), Type.atom("nil")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Finch.Request", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				Interpreter.matchOperator(
					Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.tuple([
							Type.map([
								[Type.atom("__struct__"), Type.atom("Elixir.Finch.Request")],
								[Type.atom("body"), Type.atom("nil")],
								[Type.atom("headers"), Type.atom("nil")],
								[Type.atom("host"), Type.atom("nil")],
								[Type.atom("method"), Type.atom("nil")],
								[Type.atom("path"), Type.atom("nil")],
								[Type.atom("pool_tag"), Type.atom("default")],
								[Type.atom("port"), Type.atom("nil")],
								[Type.atom("private"), Type.map([])],
								[Type.atom("query"), Type.atom("nil")],
								[Type.atom("scheme"), Type.atom("nil")],
								[Type.atom("unix_socket"), Type.atom("nil")],
							]),
							Type.list([
								Type.atom("scheme"),
								Type.atom("host"),
								Type.atom("port"),
								Type.atom("method"),
								Type.atom("path"),
								Type.atom("headers"),
								Type.atom("body"),
								Type.atom("query"),
							]),
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.tuple([
											Type.variablePattern("map_3"),
											Type.variablePattern("keys_4"),
										]),
									],
									guards: [],
									body: (context) => {
										return Type.tuple([
											Elixir_Map["merge/2"](
												context.vars.map_3,
												Type.map([[context.vars.key_1, context.vars.val_2]]),
											),
											Elixir_List["delete/2"](
												context.vars.keys_4,
												context.vars.key_1,
											),
										]);
									},
								},
							],
							context,
						),
					),
					Type.tuple([
						Type.variablePattern("map_5"),
						Type.variablePattern("keys_6"),
					]),
					context,
				);
				Interpreter.updateVarsToMatchedValues(context);
				return Interpreter.case(
					context.vars.keys_6,
					[
						{
							match: Type.list([]),
							guards: [],
							body: (context) => {
								return context.vars.map_5;
							},
						},
						{
							match: Type.matchPlaceholder(),
							guards: [],
							body: (context) => {
								return Erlang["error/1"](
									Elixir_ArgumentError["exception/1"](
										Type.bitstring([
											Type.bitstringSegment(
												Type.string(
													"the following keys must also be given when building ",
												),
												{ type: "binary" },
											),
											Type.bitstringSegment(Type.string("struct "), {
												type: "binary",
											}),
											Type.bitstringSegment(
												Elixir_Kernel["inspect/1"](
													Type.atom("Elixir.Finch.Request"),
												),
												{ type: "binary" },
											),
											Type.bitstringSegment(Type.string(": "), {
												type: "binary",
											}),
											Type.bitstringSegment(
												Elixir_Kernel["inspect/1"](context.vars.keys_6),
												{ type: "binary" },
											),
										]),
									),
								);
							},
						},
					],
					context,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Finch.Response",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Finch.Response")],
						[Type.atom("body"), Type.bitstring("")],
						[Type.atom("headers"), Type.list([])],
						[Type.atom("status"), Type.atom("nil")],
						[Type.atom("trailers"), Type.list([])],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Finch.Response",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__struct__"), Type.atom("Elixir.Finch.Response")],
							[Type.atom("body"), Type.bitstring("")],
							[Type.atom("headers"), Type.list([])],
							[Type.atom("status"), Type.atom("nil")],
							[Type.atom("trailers"), Type.list([])],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Finch.TransportError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Finch.TransportError")],
						[Type.atom("reason"), Type.atom("nil")],
						[Type.atom("source"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Finch.TransportError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Finch.TransportError"),
							],
							[Type.atom("reason"), Type.atom("nil")],
							[Type.atom("source"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction("HPAX.Table", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.HPAX.Table")],
					[Type.atom("entries"), Type.list([])],
					[Type.atom("huffman_encoding"), Type.atom("nil")],
					[Type.atom("length"), Type.integer(0n)],
					[Type.atom("max_table_size"), Type.atom("nil")],
					[Type.atom("pending_minimum_resize"), Type.atom("nil")],
					[Type.atom("protocol_max_table_size"), Type.atom("nil")],
					[Type.atom("size"), Type.integer(0n)],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("HPAX.Table", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				Interpreter.matchOperator(
					Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.tuple([
							Type.map([
								[Type.atom("__struct__"), Type.atom("Elixir.HPAX.Table")],
								[Type.atom("entries"), Type.list([])],
								[Type.atom("huffman_encoding"), Type.atom("nil")],
								[Type.atom("length"), Type.integer(0n)],
								[Type.atom("max_table_size"), Type.atom("nil")],
								[Type.atom("pending_minimum_resize"), Type.atom("nil")],
								[Type.atom("protocol_max_table_size"), Type.atom("nil")],
								[Type.atom("size"), Type.integer(0n)],
							]),
							Type.list([
								Type.atom("max_table_size"),
								Type.atom("huffman_encoding"),
							]),
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.tuple([
											Type.variablePattern("map_3"),
											Type.variablePattern("keys_4"),
										]),
									],
									guards: [],
									body: (context) => {
										return Type.tuple([
											Elixir_Map["merge/2"](
												context.vars.map_3,
												Type.map([[context.vars.key_1, context.vars.val_2]]),
											),
											Elixir_List["delete/2"](
												context.vars.keys_4,
												context.vars.key_1,
											),
										]);
									},
								},
							],
							context,
						),
					),
					Type.tuple([
						Type.variablePattern("map_5"),
						Type.variablePattern("keys_6"),
					]),
					context,
				);
				Interpreter.updateVarsToMatchedValues(context);
				return Interpreter.case(
					context.vars.keys_6,
					[
						{
							match: Type.list([]),
							guards: [],
							body: (context) => {
								return context.vars.map_5;
							},
						},
						{
							match: Type.matchPlaceholder(),
							guards: [],
							body: (context) => {
								return Erlang["error/1"](
									Elixir_ArgumentError["exception/1"](
										Type.bitstring([
											Type.bitstringSegment(
												Type.string(
													"the following keys must also be given when building ",
												),
												{ type: "binary" },
											),
											Type.bitstringSegment(Type.string("struct "), {
												type: "binary",
											}),
											Type.bitstringSegment(
												Elixir_Kernel["inspect/1"](
													Type.atom("Elixir.HPAX.Table"),
												),
												{ type: "binary" },
											),
											Type.bitstringSegment(Type.string(": "), {
												type: "binary",
											}),
											Type.bitstringSegment(
												Elixir_Kernel["inspect/1"](context.vars.keys_6),
												{ type: "binary" },
											),
										]),
									),
								);
							},
						},
					],
					context,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Hologram.Router.Helpers",
		"page_bundle_path",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("page_digest_0")],
				guards: [],
				body: (context) => {
					return Type.bitstring([
						Type.bitstringSegment(Type.string("/hologram/page-"), {
							type: "binary",
						}),
						Type.bitstringSegment(
							Elixir_String_Chars["to_string/1"](context.vars.page_digest_0),
							{ type: "binary" },
						),
						Type.bitstringSegment(Type.string(".js"), { type: "binary" }),
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Link",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("to"),
								Type.list([
									Type.atom("module"),
									Type.atom("string"),
									Type.atom("tuple"),
								]),
								Type.list([]),
							]),
							Type.tuple([
								Type.atom("style"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("rel"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("class"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Link",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("a"),
											Type.list([
												Type.tuple([
													Type.bitstring("href"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_Hologram_Router_Helpers["page_path/1"](
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("to"),
																	),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("class"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("rel"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("rel"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("style"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("style"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("$pointerdown"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Type.atom("__prefetch_page__"),
																Type.list([
																	Type.tuple([
																		Type.atom("to"),
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("to"),
																		),
																	]),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("$click"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Type.atom("__load_prefetched_page__"),
																Type.list([
																	Type.tuple([
																		Type.atom("to"),
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("to"),
																		),
																	]),
																]),
															]),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("slot"),
													Type.list([]),
													Type.list([]),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Runtime",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("page_mounted?"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("page_mounted?"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("page_digest"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("page_digest"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("instance_id"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("instance_id"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("initial_page?"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("initial_page?"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("csrf_token"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("csrf_token"),
										]),
									]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Runtime",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("initial_page?"),
												),
												[
													{
														match: Type.variablePattern("x_1"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_1,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_1,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return context.vars.x_1;
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Interpreter.case(
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("page_mounted?"),
																),
																[
																	{
																		match: Type.variablePattern("x_2"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_2,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_2,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return Type.atom("true");
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Type.atom("false");
																		},
																	},
																],
																context,
															);
														},
													},
												],
												context,
											),
											[
												{
													match: Type.variablePattern("x_3"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_3,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_3,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			'\n    globalThis.Hologram ??= {};\n    globalThis.Hologram._pendingJsInteropActions = [];\n    globalThis.Hologram.assetManifest = $ASSET_MANIFEST_JS_PLACEHOLDER;\n    globalThis.Hologram.csrfToken = "',
																		),
																	]),
																	Type.tuple([
																		Type.atom("expression"),
																		Type.tuple([
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("csrf_token"),
																			),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			'";\n    globalThis.Hologram.instanceId = "',
																		),
																	]),
																	Type.tuple([
																		Type.atom("expression"),
																		Type.tuple([
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("instance_id"),
																			),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			'";\n\n    globalThis.Hologram.dispatchAction = function(actionName, target, params) {\n      globalThis.Hologram._pendingJsInteropActions.push([actionName, target, params]);\n    }\n  ',
																		),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("page_mounted?"),
												),
												[
													{
														match: Type.variablePattern("x_4"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_4,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_4,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return Type.atom("true");
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Type.atom("false");
														},
													},
												],
												context,
											),
											[
												{
													match: Type.atom("false"),
													guards: [],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.atom("true"),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			"\n    \n      globalThis.Hologram.pageMountData = (deps) => {\n        const Type = deps.Type;\n        \n        return {\n          componentRegistry: $COMPONENT_REGISTRY_JS_PLACEHOLDER,\n          pageModule: $PAGE_MODULE_JS_PLACEHOLDER,\n          pageParams: $PAGE_PARAMS_JS_PLACEHOLDER,\n          selfEchoes: $SELF_ECHOES_JS_PLACEHOLDER,\n          subReceiptAdds: $SUB_RECEIPT_ADDS_JS_PLACEHOLDER,\n          subReceiptDrops: $SUB_RECEIPT_DROPS_JS_PLACEHOLDER\n        };\n      };\n    ",
																		),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("initial_page?"),
												),
												[
													{
														match: Type.variablePattern("x_5"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_5,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_5,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return context.vars.x_5;
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Interpreter.case(
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("page_mounted?"),
																),
																[
																	{
																		match: Type.variablePattern("x_6"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_6,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_6,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return Type.atom("true");
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Type.atom("false");
																		},
																	},
																],
																context,
															);
														},
													},
												],
												context,
											),
											[
												{
													match: Type.variablePattern("x_7"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_7,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_7,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([
																	Type.tuple([
																		Type.bitstring("async"),
																		Type.list([]),
																	]),
																	Type.tuple([
																		Type.bitstring("src"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Elixir_Hologram_Router_Helpers[
																						"asset_path/1"
																					](
																						Type.bitstring(
																							"hologram/runtime.js",
																						),
																					),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.list([]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("page_mounted?"),
												),
												[
													{
														match: Type.variablePattern("x_8"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_8,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_8,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return Type.atom("true");
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Type.atom("false");
														},
													},
												],
												context,
											),
											[
												{
													match: Type.atom("false"),
													guards: [],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.atom("true"),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([
																	Type.tuple([
																		Type.bitstring("async"),
																		Type.list([]),
																	]),
																	Type.tuple([
																		Type.bitstring("src"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Elixir_Hologram_Router_Helpers[
																						"page_bundle_path/1"
																					](
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("page_digest"),
																						),
																					),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.list([]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction("Inspect.Error", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__exception__"), Type.atom("true")],
					[Type.atom("__struct__"), Type.atom("Elixir.Inspect.Error")],
					[Type.atom("exception_message"), Type.atom("nil")],
					[Type.atom("exception_module"), Type.atom("nil")],
					[Type.atom("inspected_struct"), Type.atom("nil")],
					[Type.atom("stacktrace"), Type.atom("nil")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Inspect.Error", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				Interpreter.matchOperator(
					Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.tuple([
							Type.map([
								[Type.atom("__exception__"), Type.atom("true")],
								[Type.atom("__struct__"), Type.atom("Elixir.Inspect.Error")],
								[Type.atom("exception_message"), Type.atom("nil")],
								[Type.atom("exception_module"), Type.atom("nil")],
								[Type.atom("inspected_struct"), Type.atom("nil")],
								[Type.atom("stacktrace"), Type.atom("nil")],
							]),
							Type.list([
								Type.atom("exception_module"),
								Type.atom("exception_message"),
								Type.atom("stacktrace"),
								Type.atom("inspected_struct"),
							]),
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.tuple([
											Type.variablePattern("map_3"),
											Type.variablePattern("keys_4"),
										]),
									],
									guards: [],
									body: (context) => {
										return Type.tuple([
											Elixir_Map["merge/2"](
												context.vars.map_3,
												Type.map([[context.vars.key_1, context.vars.val_2]]),
											),
											Elixir_List["delete/2"](
												context.vars.keys_4,
												context.vars.key_1,
											),
										]);
									},
								},
							],
							context,
						),
					),
					Type.tuple([
						Type.variablePattern("map_5"),
						Type.variablePattern("keys_6"),
					]),
					context,
				);
				Interpreter.updateVarsToMatchedValues(context);
				return Interpreter.case(
					context.vars.keys_6,
					[
						{
							match: Type.list([]),
							guards: [],
							body: (context) => {
								return context.vars.map_5;
							},
						},
						{
							match: Type.matchPlaceholder(),
							guards: [],
							body: (context) => {
								return Erlang["error/1"](
									Elixir_ArgumentError["exception/1"](
										Type.bitstring([
											Type.bitstringSegment(
												Type.string(
													"the following keys must also be given when building ",
												),
												{ type: "binary" },
											),
											Type.bitstringSegment(Type.string("struct "), {
												type: "binary",
											}),
											Type.bitstringSegment(
												Elixir_Kernel["inspect/1"](
													Type.atom("Elixir.Inspect.Error"),
												),
												{ type: "binary" },
											),
											Type.bitstringSegment(Type.string(": "), {
												type: "binary",
											}),
											Type.bitstringSegment(
												Elixir_Kernel["inspect/1"](context.vars.keys_6),
												{ type: "binary" },
											),
										]),
									),
								);
							},
						},
					],
					context,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Inspect.Opts", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Inspect.Opts")],
					[Type.atom("base"), Type.atom("decimal")],
					[Type.atom("binaries"), Type.atom("infer")],
					[Type.atom("char_lists"), Type.atom("infer")],
					[Type.atom("charlists"), Type.atom("infer")],
					[Type.atom("custom_options"), Type.list([])],
					[
						Type.atom("inspect_fun"),
						Type.functionCapture(
							"Inspect",
							"inspect",
							2,
							[
								{
									params: (context) => [
										Type.variablePattern("$1"),
										Type.variablePattern("$2"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Inspect["inspect/2"](
											context.vars["$1"],
											context.vars["$2"],
										);
									},
								},
							],
							context,
						),
					],
					[Type.atom("limit"), Type.integer(100n)],
					[Type.atom("pretty"), Type.atom("false")],
					[Type.atom("printable_limit"), Type.integer(4096n)],
					[Type.atom("safe"), Type.atom("true")],
					[Type.atom("structs"), Type.atom("true")],
					[Type.atom("syntax_colors"), Type.list([])],
					[Type.atom("width"), Type.integer(80n)],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Inspect.Opts", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Inspect.Opts")],
						[Type.atom("base"), Type.atom("decimal")],
						[Type.atom("binaries"), Type.atom("infer")],
						[Type.atom("char_lists"), Type.atom("infer")],
						[Type.atom("charlists"), Type.atom("infer")],
						[Type.atom("custom_options"), Type.list([])],
						[
							Type.atom("inspect_fun"),
							Type.functionCapture(
								"Inspect",
								"inspect",
								2,
								[
									{
										params: (context) => [
											Type.variablePattern("$1"),
											Type.variablePattern("$2"),
										],
										guards: [],
										body: (context) => {
											return Elixir_Inspect["inspect/2"](
												context.vars["$1"],
												context.vars["$2"],
											);
										},
									},
								],
								context,
							),
						],
						[Type.atom("limit"), Type.integer(100n)],
						[Type.atom("pretty"), Type.atom("false")],
						[Type.atom("printable_limit"), Type.integer(4096n)],
						[Type.atom("safe"), Type.atom("true")],
						[Type.atom("structs"), Type.atom("true")],
						[Type.atom("syntax_colors"), Type.list([])],
						[Type.atom("width"), Type.integer(80n)],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Jason.DecodeError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Jason.DecodeError")],
						[Type.atom("data"), Type.atom("nil")],
						[Type.atom("position"), Type.atom("nil")],
						[Type.atom("token"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Jason.DecodeError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[Type.atom("__struct__"), Type.atom("Elixir.Jason.DecodeError")],
							[Type.atom("data"), Type.atom("nil")],
							[Type.atom("position"), Type.atom("nil")],
							[Type.atom("token"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Jason.EncodeError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Jason.EncodeError")],
						[Type.atom("message"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Jason.EncodeError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[Type.atom("__struct__"), Type.atom("Elixir.Jason.EncodeError")],
							[Type.atom("message"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Jason.Fragment",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Jason.Fragment")],
						[Type.atom("encode"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Jason.Fragment",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__struct__"), Type.atom("Elixir.Jason.Fragment")],
							[Type.atom("encode"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction("Macro.Env", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Macro.Env")],
					[Type.atom("aliases"), Type.list([])],
					[Type.atom("context"), Type.atom("nil")],
					[Type.atom("context_modules"), Type.list([])],
					[Type.atom("file"), Type.bitstring("nofile")],
					[Type.atom("function"), Type.atom("nil")],
					[Type.atom("functions"), Type.list([])],
					[Type.atom("lexical_tracker"), Type.atom("nil")],
					[Type.atom("line"), Type.integer(0n)],
					[Type.atom("macro_aliases"), Type.list([])],
					[Type.atom("macros"), Type.list([])],
					[Type.atom("module"), Type.atom("nil")],
					[Type.atom("requires"), Type.list([])],
					[Type.atom("tracers"), Type.list([])],
					[Type.atom("versioned_vars"), Type.map([])],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Macro.Env", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Erlang_Lists["foldl/3"](
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("acc_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.acc_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
					Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Macro.Env")],
						[Type.atom("aliases"), Type.list([])],
						[Type.atom("context"), Type.atom("nil")],
						[Type.atom("context_modules"), Type.list([])],
						[Type.atom("file"), Type.bitstring("nofile")],
						[Type.atom("function"), Type.atom("nil")],
						[Type.atom("functions"), Type.list([])],
						[Type.atom("lexical_tracker"), Type.atom("nil")],
						[Type.atom("line"), Type.integer(0n)],
						[Type.atom("macro_aliases"), Type.list([])],
						[Type.atom("macros"), Type.list([])],
						[Type.atom("module"), Type.atom("nil")],
						[Type.atom("requires"), Type.list([])],
						[Type.atom("tracers"), Type.list([])],
						[Type.atom("versioned_vars"), Type.map([])],
					]),
					context.vars.kv_0,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Mint.HTTP1", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Mint.HTTP1")],
					[Type.atom("buffer"), Type.bitstring("")],
					[Type.atom("case_sensitive_headers"), Type.atom("nil")],
					[Type.atom("host"), Type.atom("nil")],
					[Type.atom("log"), Type.atom("false")],
					[Type.atom("mode"), Type.atom("nil")],
					[Type.atom("optional_responses"), Type.list([])],
					[Type.atom("port"), Type.atom("nil")],
					[Type.atom("private"), Type.map([])],
					[Type.atom("proxy_headers"), Type.list([])],
					[Type.atom("request"), Type.atom("nil")],
					[Type.atom("requests"), Type.tuple([Type.list([]), Type.list([])])],
					[Type.atom("scheme_as_string"), Type.atom("nil")],
					[Type.atom("skip_target_validation"), Type.atom("nil")],
					[Type.atom("socket"), Type.atom("nil")],
					[Type.atom("state"), Type.atom("closed")],
					[Type.atom("streaming_request"), Type.atom("nil")],
					[Type.atom("transport"), Type.atom("nil")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Mint.HTTP1", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Mint.HTTP1")],
						[Type.atom("buffer"), Type.bitstring("")],
						[Type.atom("case_sensitive_headers"), Type.atom("nil")],
						[Type.atom("host"), Type.atom("nil")],
						[Type.atom("log"), Type.atom("false")],
						[Type.atom("mode"), Type.atom("nil")],
						[Type.atom("optional_responses"), Type.list([])],
						[Type.atom("port"), Type.atom("nil")],
						[Type.atom("private"), Type.map([])],
						[Type.atom("proxy_headers"), Type.list([])],
						[Type.atom("request"), Type.atom("nil")],
						[Type.atom("requests"), Type.tuple([Type.list([]), Type.list([])])],
						[Type.atom("scheme_as_string"), Type.atom("nil")],
						[Type.atom("skip_target_validation"), Type.atom("nil")],
						[Type.atom("socket"), Type.atom("nil")],
						[Type.atom("state"), Type.atom("closed")],
						[Type.atom("streaming_request"), Type.atom("nil")],
						[Type.atom("transport"), Type.atom("nil")],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Mint.HTTP2", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Mint.HTTP2")],
					[Type.atom("authority"), Type.atom("nil")],
					[Type.atom("buffer"), Type.bitstring("")],
					[
						Type.atom("client_settings"),
						Type.map([
							[Type.atom("enable_push"), Type.atom("true")],
							[Type.atom("initial_window_size"), Type.integer(4194304n)],
							[Type.atom("max_concurrent_streams"), Type.integer(100n)],
							[Type.atom("max_frame_size"), Type.integer(16384n)],
							[Type.atom("max_header_list_size"), Type.atom("infinity")],
						]),
					],
					[
						Type.atom("client_settings_queue"),
						Type.tuple([Type.list([]), Type.list([])]),
					],
					[
						Type.atom("decode_table"),
						Type.map([
							[Type.atom("__struct__"), Type.atom("Elixir.HPAX.Table")],
							[Type.atom("entries"), Type.list([])],
							[Type.atom("huffman_encoding"), Type.atom("never")],
							[Type.atom("length"), Type.integer(0n)],
							[Type.atom("max_table_size"), Type.integer(4096n)],
							[Type.atom("pending_minimum_resize"), Type.atom("nil")],
							[Type.atom("protocol_max_table_size"), Type.integer(4096n)],
							[Type.atom("size"), Type.integer(0n)],
						]),
					],
					[
						Type.atom("encode_table"),
						Type.map([
							[Type.atom("__struct__"), Type.atom("Elixir.HPAX.Table")],
							[Type.atom("entries"), Type.list([])],
							[Type.atom("huffman_encoding"), Type.atom("never")],
							[Type.atom("length"), Type.integer(0n)],
							[Type.atom("max_table_size"), Type.integer(4096n)],
							[Type.atom("pending_minimum_resize"), Type.atom("nil")],
							[Type.atom("protocol_max_table_size"), Type.integer(4096n)],
							[Type.atom("size"), Type.integer(0n)],
						]),
					],
					[Type.atom("headers_being_processed"), Type.atom("nil")],
					[Type.atom("hostname"), Type.atom("nil")],
					[Type.atom("log"), Type.atom("false")],
					[Type.atom("mode"), Type.atom("nil")],
					[Type.atom("next_stream_id"), Type.integer(3n)],
					[Type.atom("open_client_stream_count"), Type.integer(0n)],
					[Type.atom("open_server_stream_count"), Type.integer(0n)],
					[Type.atom("ping_queue"), Type.tuple([Type.list([]), Type.list([])])],
					[Type.atom("port"), Type.atom("nil")],
					[Type.atom("private"), Type.map([])],
					[Type.atom("proxy_headers"), Type.list([])],
					[Type.atom("receive_window_remaining"), Type.integer(65535n)],
					[Type.atom("receive_window_size"), Type.integer(65535n)],
					[Type.atom("receive_window_update_threshold"), Type.integer(160000n)],
					[Type.atom("ref_to_stream_id"), Type.map([])],
					[Type.atom("scheme"), Type.atom("nil")],
					[Type.atom("send_window_size"), Type.integer(65535n)],
					[
						Type.atom("server_settings"),
						Type.map([
							[Type.atom("enable_connect_protocol"), Type.atom("false")],
							[Type.atom("enable_push"), Type.atom("true")],
							[Type.atom("initial_window_size"), Type.integer(65535n)],
							[Type.atom("max_concurrent_streams"), Type.integer(100n)],
							[Type.atom("max_frame_size"), Type.integer(16384n)],
							[Type.atom("max_header_list_size"), Type.atom("infinity")],
						]),
					],
					[Type.atom("socket"), Type.atom("nil")],
					[Type.atom("state"), Type.atom("nil")],
					[Type.atom("streams"), Type.map([])],
					[Type.atom("transport"), Type.atom("nil")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Mint.HTTP2", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Mint.HTTP2")],
						[Type.atom("authority"), Type.atom("nil")],
						[Type.atom("buffer"), Type.bitstring("")],
						[
							Type.atom("client_settings"),
							Type.map([
								[Type.atom("enable_push"), Type.atom("true")],
								[Type.atom("initial_window_size"), Type.integer(4194304n)],
								[Type.atom("max_concurrent_streams"), Type.integer(100n)],
								[Type.atom("max_frame_size"), Type.integer(16384n)],
								[Type.atom("max_header_list_size"), Type.atom("infinity")],
							]),
						],
						[
							Type.atom("client_settings_queue"),
							Type.tuple([Type.list([]), Type.list([])]),
						],
						[
							Type.atom("decode_table"),
							Type.map([
								[Type.atom("__struct__"), Type.atom("Elixir.HPAX.Table")],
								[Type.atom("entries"), Type.list([])],
								[Type.atom("huffman_encoding"), Type.atom("never")],
								[Type.atom("length"), Type.integer(0n)],
								[Type.atom("max_table_size"), Type.integer(4096n)],
								[Type.atom("pending_minimum_resize"), Type.atom("nil")],
								[Type.atom("protocol_max_table_size"), Type.integer(4096n)],
								[Type.atom("size"), Type.integer(0n)],
							]),
						],
						[
							Type.atom("encode_table"),
							Type.map([
								[Type.atom("__struct__"), Type.atom("Elixir.HPAX.Table")],
								[Type.atom("entries"), Type.list([])],
								[Type.atom("huffman_encoding"), Type.atom("never")],
								[Type.atom("length"), Type.integer(0n)],
								[Type.atom("max_table_size"), Type.integer(4096n)],
								[Type.atom("pending_minimum_resize"), Type.atom("nil")],
								[Type.atom("protocol_max_table_size"), Type.integer(4096n)],
								[Type.atom("size"), Type.integer(0n)],
							]),
						],
						[Type.atom("headers_being_processed"), Type.atom("nil")],
						[Type.atom("hostname"), Type.atom("nil")],
						[Type.atom("log"), Type.atom("false")],
						[Type.atom("mode"), Type.atom("nil")],
						[Type.atom("next_stream_id"), Type.integer(3n)],
						[Type.atom("open_client_stream_count"), Type.integer(0n)],
						[Type.atom("open_server_stream_count"), Type.integer(0n)],
						[
							Type.atom("ping_queue"),
							Type.tuple([Type.list([]), Type.list([])]),
						],
						[Type.atom("port"), Type.atom("nil")],
						[Type.atom("private"), Type.map([])],
						[Type.atom("proxy_headers"), Type.list([])],
						[Type.atom("receive_window_remaining"), Type.integer(65535n)],
						[Type.atom("receive_window_size"), Type.integer(65535n)],
						[
							Type.atom("receive_window_update_threshold"),
							Type.integer(160000n),
						],
						[Type.atom("ref_to_stream_id"), Type.map([])],
						[Type.atom("scheme"), Type.atom("nil")],
						[Type.atom("send_window_size"), Type.integer(65535n)],
						[
							Type.atom("server_settings"),
							Type.map([
								[Type.atom("enable_connect_protocol"), Type.atom("false")],
								[Type.atom("enable_push"), Type.atom("true")],
								[Type.atom("initial_window_size"), Type.integer(65535n)],
								[Type.atom("max_concurrent_streams"), Type.integer(100n)],
								[Type.atom("max_frame_size"), Type.integer(16384n)],
								[Type.atom("max_header_list_size"), Type.atom("infinity")],
							]),
						],
						[Type.atom("socket"), Type.atom("nil")],
						[Type.atom("state"), Type.atom("nil")],
						[Type.atom("streams"), Type.map([])],
						[Type.atom("transport"), Type.atom("nil")],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Mint.HTTPError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Mint.HTTPError")],
						[Type.atom("module"), Type.atom("nil")],
						[Type.atom("reason"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Mint.HTTPError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[Type.atom("__struct__"), Type.atom("Elixir.Mint.HTTPError")],
							[Type.atom("module"), Type.atom("nil")],
							[Type.atom("reason"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Mint.TransportError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Mint.TransportError")],
						[Type.atom("reason"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Mint.TransportError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Mint.TransportError"),
							],
							[Type.atom("reason"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Oban.Cron.Expression",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Oban.Cron.Expression")],
						[Type.atom("days"), Type.atom("nil")],
						[Type.atom("hours"), Type.atom("nil")],
						[Type.atom("input"), Type.atom("nil")],
						[Type.atom("minutes"), Type.atom("nil")],
						[Type.atom("months"), Type.atom("nil")],
						[Type.atom("reboot?"), Type.atom("false")],
						[Type.atom("weekdays"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Oban.Cron.Expression",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Oban.Cron.Expression"),
							],
							[Type.atom("days"), Type.atom("nil")],
							[Type.atom("hours"), Type.atom("nil")],
							[Type.atom("input"), Type.atom("nil")],
							[Type.atom("minutes"), Type.atom("nil")],
							[Type.atom("months"), Type.atom("nil")],
							[Type.atom("reboot?"), Type.atom("false")],
							[Type.atom("weekdays"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveDashboard.PageLive",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Phoenix.LiveDashboard.PageLive"),
						],
						[Type.atom("dashboard_mount_path"), Type.atom("nil")],
						[Type.atom("links"), Type.list([])],
						[Type.atom("nodes"), Type.list([])],
						[Type.atom("refresh"), Type.integer(15n)],
						[
							Type.atom("refresh_options"),
							Type.list([
								Type.tuple([Type.bitstring("1s"), Type.integer(1n)]),
								Type.tuple([Type.bitstring("2s"), Type.integer(2n)]),
								Type.tuple([Type.bitstring("5s"), Type.integer(5n)]),
								Type.tuple([Type.bitstring("15s"), Type.integer(15n)]),
								Type.tuple([Type.bitstring("30s"), Type.integer(30n)]),
							]),
						],
						[Type.atom("refresher?"), Type.atom("true")],
						[Type.atom("timer"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveDashboard.PageLive",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Phoenix.LiveDashboard.PageLive"),
							],
							[Type.atom("dashboard_mount_path"), Type.atom("nil")],
							[Type.atom("links"), Type.list([])],
							[Type.atom("nodes"), Type.list([])],
							[Type.atom("refresh"), Type.integer(15n)],
							[
								Type.atom("refresh_options"),
								Type.list([
									Type.tuple([Type.bitstring("1s"), Type.integer(1n)]),
									Type.tuple([Type.bitstring("2s"), Type.integer(2n)]),
									Type.tuple([Type.bitstring("5s"), Type.integer(5n)]),
									Type.tuple([Type.bitstring("15s"), Type.integer(15n)]),
									Type.tuple([Type.bitstring("30s"), Type.integer(30n)]),
								]),
							],
							[Type.atom("refresher?"), Type.atom("true")],
							[Type.atom("timer"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveView.Socket",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Phoenix.LiveView.Socket"),
						],
						[
							Type.atom("assigns"),
							Type.map([[Type.atom("__changed__"), Type.map([])]]),
						],
						[Type.atom("endpoint"), Type.atom("nil")],
						[Type.atom("host_uri"), Type.atom("nil")],
						[Type.atom("id"), Type.atom("nil")],
						[Type.atom("parent_pid"), Type.atom("nil")],
						[
							Type.atom("private"),
							Type.map([[Type.atom("live_temp"), Type.map([])]]),
						],
						[Type.atom("redirected"), Type.atom("nil")],
						[Type.atom("root_pid"), Type.atom("nil")],
						[Type.atom("router"), Type.atom("nil")],
						[Type.atom("sticky?"), Type.atom("false")],
						[Type.atom("transport_pid"), Type.atom("nil")],
						[Type.atom("view"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveView.Socket",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Phoenix.LiveView.Socket"),
							],
							[
								Type.atom("assigns"),
								Type.map([[Type.atom("__changed__"), Type.map([])]]),
							],
							[Type.atom("endpoint"), Type.atom("nil")],
							[Type.atom("host_uri"), Type.atom("nil")],
							[Type.atom("id"), Type.atom("nil")],
							[Type.atom("parent_pid"), Type.atom("nil")],
							[
								Type.atom("private"),
								Type.map([[Type.atom("live_temp"), Type.map([])]]),
							],
							[Type.atom("redirected"), Type.atom("nil")],
							[Type.atom("root_pid"), Type.atom("nil")],
							[Type.atom("router"), Type.atom("nil")],
							[Type.atom("sticky?"), Type.atom("false")],
							[Type.atom("transport_pid"), Type.atom("nil")],
							[Type.atom("view"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveView.Socket.AssignsNotInSocket",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__assigns__"), Type.atom("nil")],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Phoenix.LiveView.Socket.AssignsNotInSocket"),
						],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveView.Socket.AssignsNotInSocket",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__assigns__"), Type.atom("nil")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Phoenix.LiveView.Socket.AssignsNotInSocket"),
							],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveView.UploadConfig",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Phoenix.LiveView.UploadConfig"),
						],
						[Type.atom("accept"), Type.list([])],
						[
							Type.atom("acceptable_exts"),
							Type.map([
								[Type.atom("__struct__"), Type.atom("Elixir.MapSet")],
								[Type.atom("map"), Type.map([])],
							]),
						],
						[
							Type.atom("acceptable_types"),
							Type.map([
								[Type.atom("__struct__"), Type.atom("Elixir.MapSet")],
								[Type.atom("map"), Type.map([])],
							]),
						],
						[Type.atom("allowed?"), Type.atom("false")],
						[Type.atom("auto_upload?"), Type.atom("false")],
						[Type.atom("chunk_size"), Type.integer(64000n)],
						[Type.atom("chunk_timeout"), Type.integer(10000n)],
						[Type.atom("cid"), Type.atom("unregistered")],
						[Type.atom("client_key"), Type.atom("nil")],
						[Type.atom("entries"), Type.list([])],
						[Type.atom("entry_refs_to_metas"), Type.map([])],
						[Type.atom("entry_refs_to_pids"), Type.map([])],
						[Type.atom("errors"), Type.list([])],
						[Type.atom("external"), Type.atom("false")],
						[Type.atom("max_entries"), Type.integer(1n)],
						[Type.atom("max_file_size"), Type.integer(8000000n)],
						[Type.atom("name"), Type.atom("nil")],
						[Type.atom("progress_event"), Type.atom("nil")],
						[Type.atom("ref"), Type.atom("nil")],
						[Type.atom("writer"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveView.UploadConfig",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Phoenix.LiveView.UploadConfig"),
							],
							[Type.atom("accept"), Type.list([])],
							[
								Type.atom("acceptable_exts"),
								Type.map([
									[Type.atom("__struct__"), Type.atom("Elixir.MapSet")],
									[Type.atom("map"), Type.map([])],
								]),
							],
							[
								Type.atom("acceptable_types"),
								Type.map([
									[Type.atom("__struct__"), Type.atom("Elixir.MapSet")],
									[Type.atom("map"), Type.map([])],
								]),
							],
							[Type.atom("allowed?"), Type.atom("false")],
							[Type.atom("auto_upload?"), Type.atom("false")],
							[Type.atom("chunk_size"), Type.integer(64000n)],
							[Type.atom("chunk_timeout"), Type.integer(10000n)],
							[Type.atom("cid"), Type.atom("unregistered")],
							[Type.atom("client_key"), Type.atom("nil")],
							[Type.atom("entries"), Type.list([])],
							[Type.atom("entry_refs_to_metas"), Type.map([])],
							[Type.atom("entry_refs_to_pids"), Type.map([])],
							[Type.atom("errors"), Type.list([])],
							[Type.atom("external"), Type.atom("false")],
							[Type.atom("max_entries"), Type.integer(1n)],
							[Type.atom("max_file_size"), Type.integer(8000000n)],
							[Type.atom("name"), Type.atom("nil")],
							[Type.atom("progress_event"), Type.atom("nil")],
							[Type.atom("ref"), Type.atom("nil")],
							[Type.atom("writer"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveViewTest.Element",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Phoenix.LiveViewTest.Element"),
						],
						[Type.atom("event"), Type.atom("nil")],
						[Type.atom("form_data"), Type.atom("nil")],
						[Type.atom("meta"), Type.map([])],
						[Type.atom("proxy"), Type.atom("nil")],
						[Type.atom("selector"), Type.atom("nil")],
						[Type.atom("text_filter"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveViewTest.Element",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Phoenix.LiveViewTest.Element"),
							],
							[Type.atom("event"), Type.atom("nil")],
							[Type.atom("form_data"), Type.atom("nil")],
							[Type.atom("meta"), Type.map([])],
							[Type.atom("proxy"), Type.atom("nil")],
							[Type.atom("selector"), Type.atom("nil")],
							[Type.atom("text_filter"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveViewTest.Upload",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Phoenix.LiveViewTest.Upload"),
						],
						[Type.atom("cid"), Type.atom("nil")],
						[Type.atom("config"), Type.map([])],
						[Type.atom("element"), Type.atom("nil")],
						[Type.atom("entries"), Type.list([])],
						[Type.atom("pid"), Type.atom("nil")],
						[Type.atom("ref"), Type.atom("nil")],
						[Type.atom("selector"), Type.atom("nil")],
						[Type.atom("view"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveViewTest.Upload",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Phoenix.LiveViewTest.Upload"),
							],
							[Type.atom("cid"), Type.atom("nil")],
							[Type.atom("config"), Type.map([])],
							[Type.atom("element"), Type.atom("nil")],
							[Type.atom("entries"), Type.list([])],
							[Type.atom("pid"), Type.atom("nil")],
							[Type.atom("ref"), Type.atom("nil")],
							[Type.atom("selector"), Type.atom("nil")],
							[Type.atom("view"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveViewTest.View",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Phoenix.LiveViewTest.View"),
						],
						[Type.atom("endpoint"), Type.atom("nil")],
						[Type.atom("id"), Type.atom("nil")],
						[Type.atom("module"), Type.atom("nil")],
						[Type.atom("pid"), Type.atom("nil")],
						[Type.atom("proxy"), Type.atom("nil")],
						[Type.atom("target"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.LiveViewTest.View",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Phoenix.LiveViewTest.View"),
							],
							[Type.atom("endpoint"), Type.atom("nil")],
							[Type.atom("id"), Type.atom("nil")],
							[Type.atom("module"), Type.atom("nil")],
							[Type.atom("pid"), Type.atom("nil")],
							[Type.atom("proxy"), Type.atom("nil")],
							[Type.atom("target"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.Socket.Message",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Phoenix.Socket.Message"),
						],
						[Type.atom("event"), Type.atom("nil")],
						[Type.atom("join_ref"), Type.atom("nil")],
						[Type.atom("payload"), Type.atom("nil")],
						[Type.atom("ref"), Type.atom("nil")],
						[Type.atom("topic"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Phoenix.Socket.Message",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Phoenix.Socket.Message"),
							],
							[Type.atom("event"), Type.atom("nil")],
							[Type.atom("join_ref"), Type.atom("nil")],
							[Type.atom("payload"), Type.atom("nil")],
							[Type.atom("ref"), Type.atom("nil")],
							[Type.atom("topic"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction("Plug.Conn", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Plug.Conn")],
					[
						Type.atom("adapter"),
						Type.tuple([
							Type.atom("Elixir.Plug.MissingAdapter"),
							Type.atom("nil"),
						]),
					],
					[Type.atom("assigns"), Type.map([])],
					[
						Type.atom("body_params"),
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Plug.Conn.Unfetched"),
							],
							[Type.atom("aspect"), Type.atom("body_params")],
						]),
					],
					[
						Type.atom("cookies"),
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Plug.Conn.Unfetched"),
							],
							[Type.atom("aspect"), Type.atom("cookies")],
						]),
					],
					[Type.atom("halted"), Type.atom("false")],
					[Type.atom("host"), Type.bitstring("www.example.com")],
					[Type.atom("method"), Type.bitstring("GET")],
					[Type.atom("owner"), Type.atom("nil")],
					[
						Type.atom("params"),
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Plug.Conn.Unfetched"),
							],
							[Type.atom("aspect"), Type.atom("params")],
						]),
					],
					[Type.atom("path_info"), Type.list([])],
					[Type.atom("path_params"), Type.map([])],
					[Type.atom("port"), Type.integer(0n)],
					[Type.atom("private"), Type.map([])],
					[
						Type.atom("query_params"),
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Plug.Conn.Unfetched"),
							],
							[Type.atom("aspect"), Type.atom("query_params")],
						]),
					],
					[Type.atom("query_string"), Type.bitstring("")],
					[Type.atom("remote_ip"), Type.atom("nil")],
					[
						Type.atom("req_cookies"),
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Plug.Conn.Unfetched"),
							],
							[Type.atom("aspect"), Type.atom("cookies")],
						]),
					],
					[Type.atom("req_headers"), Type.list([])],
					[Type.atom("request_path"), Type.bitstring("")],
					[Type.atom("resp_body"), Type.atom("nil")],
					[Type.atom("resp_cookies"), Type.map([])],
					[
						Type.atom("resp_headers"),
						Type.list([
							Type.tuple([
								Type.bitstring("cache-control"),
								Type.bitstring("max-age=0, private, must-revalidate"),
							]),
						]),
					],
					[Type.atom("scheme"), Type.atom("http")],
					[Type.atom("script_name"), Type.list([])],
					[Type.atom("secret_key_base"), Type.atom("nil")],
					[Type.atom("state"), Type.atom("unset")],
					[Type.atom("status"), Type.atom("nil")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Plug.Conn", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Plug.Conn")],
						[
							Type.atom("adapter"),
							Type.tuple([
								Type.atom("Elixir.Plug.MissingAdapter"),
								Type.atom("nil"),
							]),
						],
						[Type.atom("assigns"), Type.map([])],
						[
							Type.atom("body_params"),
							Type.map([
								[
									Type.atom("__struct__"),
									Type.atom("Elixir.Plug.Conn.Unfetched"),
								],
								[Type.atom("aspect"), Type.atom("body_params")],
							]),
						],
						[
							Type.atom("cookies"),
							Type.map([
								[
									Type.atom("__struct__"),
									Type.atom("Elixir.Plug.Conn.Unfetched"),
								],
								[Type.atom("aspect"), Type.atom("cookies")],
							]),
						],
						[Type.atom("halted"), Type.atom("false")],
						[Type.atom("host"), Type.bitstring("www.example.com")],
						[Type.atom("method"), Type.bitstring("GET")],
						[Type.atom("owner"), Type.atom("nil")],
						[
							Type.atom("params"),
							Type.map([
								[
									Type.atom("__struct__"),
									Type.atom("Elixir.Plug.Conn.Unfetched"),
								],
								[Type.atom("aspect"), Type.atom("params")],
							]),
						],
						[Type.atom("path_info"), Type.list([])],
						[Type.atom("path_params"), Type.map([])],
						[Type.atom("port"), Type.integer(0n)],
						[Type.atom("private"), Type.map([])],
						[
							Type.atom("query_params"),
							Type.map([
								[
									Type.atom("__struct__"),
									Type.atom("Elixir.Plug.Conn.Unfetched"),
								],
								[Type.atom("aspect"), Type.atom("query_params")],
							]),
						],
						[Type.atom("query_string"), Type.bitstring("")],
						[Type.atom("remote_ip"), Type.atom("nil")],
						[
							Type.atom("req_cookies"),
							Type.map([
								[
									Type.atom("__struct__"),
									Type.atom("Elixir.Plug.Conn.Unfetched"),
								],
								[Type.atom("aspect"), Type.atom("cookies")],
							]),
						],
						[Type.atom("req_headers"), Type.list([])],
						[Type.atom("request_path"), Type.bitstring("")],
						[Type.atom("resp_body"), Type.atom("nil")],
						[Type.atom("resp_cookies"), Type.map([])],
						[
							Type.atom("resp_headers"),
							Type.list([
								Type.tuple([
									Type.bitstring("cache-control"),
									Type.bitstring("max-age=0, private, must-revalidate"),
								]),
							]),
						],
						[Type.atom("scheme"), Type.atom("http")],
						[Type.atom("script_name"), Type.list([])],
						[Type.atom("secret_key_base"), Type.atom("nil")],
						[Type.atom("state"), Type.atom("unset")],
						[Type.atom("status"), Type.atom("nil")],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Plug.Conn.InvalidQueryError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Plug.Conn.InvalidQueryError"),
						],
						[Type.atom("message"), Type.bitstring("query string is invalid")],
						[Type.atom("plug_status"), Type.integer(400n)],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Plug.Conn.InvalidQueryError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Plug.Conn.InvalidQueryError"),
							],
							[Type.atom("message"), Type.bitstring("query string is invalid")],
							[Type.atom("plug_status"), Type.integer(400n)],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Plug.Conn.Unfetched",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Plug.Conn.Unfetched")],
						[Type.atom("aspect"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Plug.Conn.Unfetched",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Plug.Conn.Unfetched"),
							],
							[Type.atom("aspect"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Plug.Parsers.RequestTooLargeError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Plug.Parsers.RequestTooLargeError"),
						],
						[
							Type.atom("message"),
							Type.bitstring(
								"the request is too large. If you are willing to process larger requests, please give a :length to Plug.Parsers",
							),
						],
						[Type.atom("plug_status"), Type.integer(413n)],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Plug.Parsers.RequestTooLargeError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Plug.Parsers.RequestTooLargeError"),
							],
							[
								Type.atom("message"),
								Type.bitstring(
									"the request is too large. If you are willing to process larger requests, please give a :length to Plug.Parsers",
								),
							],
							[Type.atom("plug_status"), Type.integer(413n)],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Plug.Parsers.UnsupportedMediaTypeError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Plug.Parsers.UnsupportedMediaTypeError"),
						],
						[Type.atom("media_type"), Type.atom("nil")],
						[Type.atom("plug_status"), Type.integer(415n)],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Plug.Parsers.UnsupportedMediaTypeError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Plug.Parsers.UnsupportedMediaTypeError"),
							],
							[Type.atom("media_type"), Type.atom("nil")],
							[Type.atom("plug_status"), Type.integer(415n)],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Req.ArchiveError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Req.ArchiveError")],
						[Type.atom("data"), Type.atom("nil")],
						[Type.atom("format"), Type.atom("nil")],
						[Type.atom("reason"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Req.ArchiveError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[Type.atom("__struct__"), Type.atom("Elixir.Req.ArchiveError")],
							[Type.atom("data"), Type.atom("nil")],
							[Type.atom("format"), Type.atom("nil")],
							[Type.atom("reason"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Req.ChecksumMismatchError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Req.ChecksumMismatchError"),
						],
						[Type.atom("actual"), Type.atom("nil")],
						[Type.atom("expected"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Req.ChecksumMismatchError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Req.ChecksumMismatchError"),
							],
							[Type.atom("actual"), Type.atom("nil")],
							[Type.atom("expected"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Req.DecompressError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Req.DecompressError")],
						[Type.atom("data"), Type.atom("nil")],
						[Type.atom("format"), Type.atom("nil")],
						[Type.atom("reason"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Req.DecompressError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Req.DecompressError"),
							],
							[Type.atom("data"), Type.atom("nil")],
							[Type.atom("format"), Type.atom("nil")],
							[Type.atom("reason"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction("Req.HTTPError", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__exception__"), Type.atom("true")],
					[Type.atom("__struct__"), Type.atom("Elixir.Req.HTTPError")],
					[Type.atom("protocol"), Type.atom("nil")],
					[Type.atom("reason"), Type.atom("nil")],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Req.HTTPError", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Req.HTTPError")],
						[Type.atom("protocol"), Type.atom("nil")],
						[Type.atom("reason"), Type.atom("nil")],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Req.Request", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Req.Request")],
					[
						Type.atom("adapter"),
						Type.functionCapture(
							"Req.Steps",
							"run_finch",
							1,
							[
								{
									params: (context) => [Type.variablePattern("$1")],
									guards: [],
									body: (context) => {
										return Elixir_Req_Steps["run_finch/1"](context.vars["$1"]);
									},
								},
							],
							context,
						),
					],
					[Type.atom("async"), Type.atom("nil")],
					[Type.atom("body"), Type.atom("nil")],
					[Type.atom("current_request_steps"), Type.list([])],
					[Type.atom("error_steps"), Type.list([])],
					[Type.atom("halted"), Type.atom("false")],
					[Type.atom("headers"), Type.map([])],
					[Type.atom("into"), Type.atom("nil")],
					[Type.atom("method"), Type.atom("get")],
					[Type.atom("options"), Type.map([])],
					[Type.atom("private"), Type.map([])],
					[
						Type.atom("registered_options"),
						Type.map([
							[Type.atom("__struct__"), Type.atom("Elixir.MapSet")],
							[Type.atom("map"), Type.map([])],
						]),
					],
					[Type.atom("request_steps"), Type.list([])],
					[Type.atom("response_steps"), Type.list([])],
					[
						Type.atom("url"),
						Type.map([
							[Type.atom("__struct__"), Type.atom("Elixir.URI")],
							[Type.atom("authority"), Type.atom("nil")],
							[Type.atom("fragment"), Type.atom("nil")],
							[Type.atom("host"), Type.atom("nil")],
							[Type.atom("path"), Type.atom("nil")],
							[Type.atom("port"), Type.atom("nil")],
							[Type.atom("query"), Type.atom("nil")],
							[Type.atom("scheme"), Type.atom("nil")],
							[Type.atom("userinfo"), Type.atom("nil")],
						]),
					],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Req.Request", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Req.Request")],
						[
							Type.atom("adapter"),
							Type.functionCapture(
								"Req.Steps",
								"run_finch",
								1,
								[
									{
										params: (context) => [Type.variablePattern("$1")],
										guards: [],
										body: (context) => {
											return Elixir_Req_Steps["run_finch/1"](
												context.vars["$1"],
											);
										},
									},
								],
								context,
							),
						],
						[Type.atom("async"), Type.atom("nil")],
						[Type.atom("body"), Type.atom("nil")],
						[Type.atom("current_request_steps"), Type.list([])],
						[Type.atom("error_steps"), Type.list([])],
						[Type.atom("halted"), Type.atom("false")],
						[Type.atom("headers"), Type.map([])],
						[Type.atom("into"), Type.atom("nil")],
						[Type.atom("method"), Type.atom("get")],
						[Type.atom("options"), Type.map([])],
						[Type.atom("private"), Type.map([])],
						[
							Type.atom("registered_options"),
							Type.map([
								[Type.atom("__struct__"), Type.atom("Elixir.MapSet")],
								[Type.atom("map"), Type.map([])],
							]),
						],
						[Type.atom("request_steps"), Type.list([])],
						[Type.atom("response_steps"), Type.list([])],
						[
							Type.atom("url"),
							Type.map([
								[Type.atom("__struct__"), Type.atom("Elixir.URI")],
								[Type.atom("authority"), Type.atom("nil")],
								[Type.atom("fragment"), Type.atom("nil")],
								[Type.atom("host"), Type.atom("nil")],
								[Type.atom("path"), Type.atom("nil")],
								[Type.atom("port"), Type.atom("nil")],
								[Type.atom("query"), Type.atom("nil")],
								[Type.atom("scheme"), Type.atom("nil")],
								[Type.atom("userinfo"), Type.atom("nil")],
							]),
						],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Req.Response", "__struct__", 0, "public", [
		{
			params: (context) => [],
			guards: [],
			body: (context) => {
				return Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Req.Response")],
					[Type.atom("body"), Type.bitstring("")],
					[Type.atom("headers"), Type.map([])],
					[Type.atom("private"), Type.map([])],
					[Type.atom("status"), Type.integer(200n)],
					[Type.atom("trailers"), Type.map([])],
				]);
			},
		},
	]);

	Interpreter.defineElixirFunction("Req.Response", "__struct__", 1, "public", [
		{
			params: (context) => [Type.variablePattern("kv_0")],
			guards: [],
			body: (context) => {
				return Elixir_Enum["reduce/3"](
					context.vars.kv_0,
					Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Req.Response")],
						[Type.atom("body"), Type.bitstring("")],
						[Type.atom("headers"), Type.map([])],
						[Type.atom("private"), Type.map([])],
						[Type.atom("status"), Type.integer(200n)],
						[Type.atom("trailers"), Type.map([])],
					]),
					Type.anonymousFunction(
						2,
						[
							{
								params: (context) => [
									Type.tuple([
										Type.variablePattern("key_1"),
										Type.variablePattern("val_2"),
									]),
									Type.variablePattern("map_3"),
								],
								guards: [],
								body: (context) => {
									return Elixir_Map["merge/2"](
										context.vars.map_3,
										Type.map([[context.vars.key_1, context.vars.val_2]]),
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Req.TooManyRedirectsError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Req.TooManyRedirectsError"),
						],
						[Type.atom("max_redirects"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Req.TooManyRedirectsError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Req.TooManyRedirectsError"),
							],
							[Type.atom("max_redirects"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Req.TransportError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Req.TransportError")],
						[Type.atom("reason"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Req.TransportError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[Type.atom("__struct__"), Type.atom("Elixir.Req.TransportError")],
							[Type.atom("reason"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Resend.Emails.Attachment",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Resend.Emails.Attachment"),
						],
						[Type.atom("content"), Type.atom("nil")],
						[Type.atom("content_id"), Type.atom("nil")],
						[Type.atom("content_type"), Type.atom("nil")],
						[Type.atom("filename"), Type.atom("nil")],
						[Type.atom("path"), Type.bitstring("")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Resend.Emails.Attachment",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Resend.Emails.Attachment"),
							],
							[Type.atom("content"), Type.atom("nil")],
							[Type.atom("content_id"), Type.atom("nil")],
							[Type.atom("content_type"), Type.atom("nil")],
							[Type.atom("filename"), Type.atom("nil")],
							[Type.atom("path"), Type.bitstring("")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Resend.Emails.Tag",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Resend.Emails.Tag")],
						[Type.atom("name"), Type.atom("nil")],
						[Type.atom("value"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Resend.Emails.Tag",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					Interpreter.matchOperator(
						Elixir_Enum["reduce/3"](
							context.vars.kv_0,
							Type.tuple([
								Type.map([
									[
										Type.atom("__struct__"),
										Type.atom("Elixir.Resend.Emails.Tag"),
									],
									[Type.atom("name"), Type.atom("nil")],
									[Type.atom("value"), Type.atom("nil")],
								]),
								Type.list([Type.atom("name")]),
							]),
							Type.anonymousFunction(
								2,
								[
									{
										params: (context) => [
											Type.tuple([
												Type.variablePattern("key_1"),
												Type.variablePattern("val_2"),
											]),
											Type.tuple([
												Type.variablePattern("map_3"),
												Type.variablePattern("keys_4"),
											]),
										],
										guards: [],
										body: (context) => {
											return Type.tuple([
												Elixir_Map["merge/2"](
													context.vars.map_3,
													Type.map([[context.vars.key_1, context.vars.val_2]]),
												),
												Elixir_List["delete/2"](
													context.vars.keys_4,
													context.vars.key_1,
												),
											]);
										},
									},
								],
								context,
							),
						),
						Type.tuple([
							Type.variablePattern("map_5"),
							Type.variablePattern("keys_6"),
						]),
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return Interpreter.case(
						context.vars.keys_6,
						[
							{
								match: Type.list([]),
								guards: [],
								body: (context) => {
									return context.vars.map_5;
								},
							},
							{
								match: Type.matchPlaceholder(),
								guards: [],
								body: (context) => {
									return Erlang["error/1"](
										Elixir_ArgumentError["exception/1"](
											Type.bitstring([
												Type.bitstringSegment(
													Type.string(
														"the following keys must also be given when building ",
													),
													{ type: "binary" },
												),
												Type.bitstringSegment(Type.string("struct "), {
													type: "binary",
												}),
												Type.bitstringSegment(
													Elixir_Kernel["inspect/1"](
														Type.atom("Elixir.Resend.Emails.Tag"),
													),
													{ type: "binary" },
												),
												Type.bitstringSegment(Type.string(": "), {
													type: "binary",
												}),
												Type.bitstringSegment(
													Elixir_Kernel["inspect/1"](context.vars.keys_6),
													{ type: "binary" },
												),
											]),
										),
									);
								},
							},
						],
						context,
					);
				},
			},
		],
	);
};

globalThis.Hologram.pageScriptLoaded = true;
document.dispatchEvent(new CustomEvent("hologram:pageScriptLoaded"));

console.debug(
	"Hologram: page script executed in",
	PerformanceTimer.diff(startTime),
);
